// src/pages/Register.jsx
import React, { useEffect, useState, useRef, useMemo } from "react";
import axios from "axios";
import "../Dashboard.css";
import { ROLES, ROLE_GROUPS } from "../constants/roles";

import Select from "react-select";

import Header from "../components/Header";
import Footer from "../components/Footer";
import ScrollToTop from "../components/ScrollTop";
import { ToastContainer, toast } from "react-toastify";

import moment from "moment";
import "moment/locale/es";
import "moment-timezone";
moment.locale("es");

import { buildGroupedSedesOptions } from "../utils/HerlperRegisters";

import {
    ImHome2,
    ImDatabase,
    ImFolderUpload,
    ImClock,
    ImUserCheck,
    ImCalendar,
    ImCross,
} from "react-icons/im";
import { useAuth } from "../provider/authProvider";

import PhoneLoader from "../components/loader/PhoneLoader";

import "flatpickr/dist/themes/material_green.css";
import Flatpickr from "flatpickr";
import { Spanish } from "flatpickr/dist/l10n/es.js";

import Clock from "../components/Clock";

import FmFinalizePopup from "../components/FmFinalizePopup";

import RegisterTableCredito from "../components/register-options/RegisterTableCredito";
import RegisterTableContado from "../components/register-options/RegisterTableContado";
import RegisterTableContadoOthers from "../components/register-options/RegisterTableContadoOthers";
import RegisterTableContadoFormateo from "../components/register-options/RegisterTableContadoFormateo";
import RegisterTableEgreso from "../components/register-options/RegisterTableEgreso";
import PaymentRegistrationWizard from "../components/register-options/PaymentRegistrationWizard";
import RegisterTableIngreso from "../components/register-options/RegisterTableIngreso";
import RegisterTableRetiro from "../components/register-options/RegisterTableRetiro";

import TableCredito from "../components/register-options/TableCredito";

import EditRegisterModal from "../components/EditRegisterModal";
import InitialValidationVideoPopup from "../components/InitialValidationVideoPopup";

import useSedeGate from "../hooks/useSedeGate";

// ========= API interna =========
const API_BASE = process.env.REACT_APP_API || "";
const CREDIT_BY_DNI_URL =
    process.env.REACT_APP_REGISTER_CREDIT_BY_DNI ||
    `${API_BASE}/register/credit-by-dni`;

/* =========================== VALIDACIONES =========================== */

function validarDatos(data) {
    const errores = [];
    let primerErrorEncontrado = false;

    const idMap = {
        cat: "catAdd",
        subCat: "subCatAdd",
        segment: "segmentAdd",
        description: "descriptionAdd",
        phone: "phoneAdd",
        phonePrice: "phonePriceAdd",
        name: "nameAdd",
        paternalSur: "paternalSurAdd",
        maternalSur: "maternalSurAdd",
        fm: "fmAdd",
        fmAmount: "fmAmountAdd",
        imei: "imeiAdd",
        dni: "dniAdd",
        email: "emailAdd",
        phoneNumber: "phoneNumberAdd",
        onlinePay: "onlinePayAdd",
        onlineAmount: "onlineAmountAdd",
        applicant: "applicantAdd",
    };

    const idMapError = {
        cat: "Categoría",
        subCat: "Subcategoría",
        segment: "Segmento",
        description: "Descripción",
        phone: "Nombre del Equipo",
        phonePrice: "Precio del Equipo",
        name: "Nombre",
        paternalSur: "Apellido Paterno",
        maternalSur: "Apellido Materno",
        fm: "FM",
        fmAmount: "Monto FM",
        imei: "IMEI",
        dni: "DNI",
        email: "Email",
        phoneNumber: "Número de Celular",
        onlinePay: "Pago Online",
        onlineAmount: "Monto Online",
        applicant: "Solicitante",
    };

    for (const key in data) {
        const value = data[key];
        const nombre = idMapError[key] || key;
        let element = null;
        if (key === "phoneAdd") {
            element = document.querySelector('[name="phone"]');
        } else {
            const id = idMap[key];
            element = document.getElementById(id);
        }

        if (!element) continue;

        const esTextoVacio =
            typeof value === "string" && value !== "0" && value.trim() === "";

        if (esTextoVacio) {
            errores.push(`${nombre} está vacío.`);
            element.classList.add("input-error");

            if (!primerErrorEncontrado) {
                element.focus();
                primerErrorEncontrado = true;
            }
        } else {
            element.classList.remove("input-error");
        }
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const camposEspeciales = [
        {
            key: "email",
            valido: emailRegex.test(data.email),
            mensaje: "El Email no es válido.",
        },
        {
            key: "imei",
            valido: /^\d{15}$/.test(data.imei),
            mensaje: "El IMEI debe tener exactamente 15 dígitos.",
        },
        {
            key: "dni",
            valido: /^\d{8}$/.test(data.dni),
            mensaje: "El DNI debe tener exactamente 8 dígitos.",
        },
        {
            key: "numberPhone",
            valido: /^\d{9}$/.test(data.numberPhone),
            mensaje: "El Número de Celular debe tener 9 dígitos.",
        },
    ];

    for (const campo of camposEspeciales) {
        const el = document.getElementById(idMap[campo.key]);
        if (data[campo.key] && !campo.valido) {
            errores.push(campo.mensaje);
            el?.classList.add("input-error");
            if (!primerErrorEncontrado && el) {
                el.focus();
                primerErrorEncontrado = true;
            }
        }
    }

    if (parseFloat(data.fmAmount) > 0 && data.fm !== "1") {
        const el = document.getElementById(idMap["fm"]);
        errores.push("Debe seleccionar 'Sí' en FM si el Monto FM es mayor a 0.");
        el?.classList.add("input-error");
        if (!primerErrorEncontrado && el) {
            el.focus();
            primerErrorEncontrado = true;
        }
    }

    if (
        parseFloat(data.onlineAmount) > 0 &&
        (!data.onlinePay || data.onlinePay === "0")
    ) {
        errores.push(
            "Debe seleccionar un método de Pago Online (Yape, Tarjeta o Transferencia).",
        );
        const el = document.getElementById("onlinePayAdd");
        el?.classList.add("input-error");
        if (!primerErrorEncontrado && el) {
            el.focus();
            primerErrorEncontrado = true;
        }
    }

    return errores;
}

const limpiarClasesRegisterTable = (elemento) => {
    // El asistente de Cuota/FM no siempre renderiza un nodo .registerTable.
    // Si el nodo no existe, no hay clases legacy que limpiar.
    if (!elemento?.classList) return;

    const clases = Array.from({ length: 9 }, (_, i) => `registerTable${i + 1}`);
    elemento.classList.remove(...clases);
};

/* ===================== Helper: parseo robusto de montos ===================== */
const parseMoney = (v) => {
    if (v == null) return 0;
    const s = String(v)
        .trim()
        .replace(/\s/g, "")
        .replace(/\./g, "")
        .replace(",", ".");
    const n = parseFloat(s);
    return Number.isFinite(n) ? n : 0;
};

/* ===================== Helper SOLO POPUP: parseo robusto (no rompe 150.00) ===================== */
const parseMoneyPopup = (v) => {
    if (v == null) return 0;

    // Limpia símbolos y espacios
    let s = String(v)
        .trim()
        .replace(/\s/g, "")
        .replace(/S\/|s\/|PEN|pen|,/g, (m) => m); // (no altera aquí, solo mantiene para lógica)

    // Elimina "S/" y cualquier cosa no numérica salvo . y ,
    s = s.replace(/S\/|s\/|PEN|pen/g, "");
    s = s.replace(/[^\d.,-]/g, "");

    if (!s) return 0;

    const hasDot = s.includes(".");
    const hasComma = s.includes(",");

    // Caso 1: tiene "." y "," => el último separador suele ser decimal
    if (hasDot && hasComma) {
        const lastDot = s.lastIndexOf(".");
        const lastComma = s.lastIndexOf(",");

        if (lastDot > lastComma) {
            // Decimal ".", miles ","
            s = s.replace(/,/g, "");
            // mantiene "."
        } else {
            // Decimal ",", miles "."
            s = s.replace(/\./g, "");
            s = s.replace(/,/g, ".");
        }
    } else if (hasComma && !hasDot) {
        // Solo "," => puede ser decimal o miles
        const parts = s.split(",");
        if (parts.length === 2 && parts[1].length <= 2) {
            // "150,50" => decimal
            s = s.replace(/,/g, ".");
        } else {
            // "1,500" => miles
            s = s.replace(/,/g, "");
        }
    } else if (hasDot && !hasComma) {
        // Solo "." => puede ser decimal o miles
        const parts = s.split(".");
        if (parts.length === 2 && parts[1].length <= 2) {
            // "150.50" => decimal (OK)
        } else {
            // "1.500" => miles
            s = s.replace(/\./g, "");
        }
    }

    const n = parseFloat(s);
    return Number.isFinite(n) ? n : 0;
};

/* ===================== Helper SOLO POPUP: construir texto para WhatsApp ===================== */
const buildWhatsappTextFromSummary = (summary) => {
    if (!summary) return "";

    const headTitle = String(summary.headTitle || "PAGO REGISTRADO").trim();
    const title = String(summary.title || "").trim();
    const sedeName = String(summary.sedeName || "").trim();
    const customerName = String(summary.customerName || "").trim();
    const dni = String(summary.dni || "").trim();
    const cuotasLine = String(summary.cuotasLine || "").trim();
    const numFeePaid =
        summary.numFeePaid != null ? String(summary.numFeePaid) : "";
    const unlockCode =
        summary.unlockCode != null ? String(summary.unlockCode).trim() : "";
    const total = Number(summary.total || 0);
    const lines = Array.isArray(summary.lines) ? summary.lines : [];
    const finalized = Boolean(summary.finalized);

    const out = [];
    if (headTitle) out.push(`*${headTitle}*`); // Bold WhatsApp
    if (title) out.push(`*${title}*`); // Bold WhatsApp
    if (sedeName) out.push(`- Sede: ${sedeName}`);
    if (customerName) out.push(`- ${customerName}`);
    if (dni) out.push(`- DNI: ${dni}`);
    if (cuotasLine) out.push(`- ${cuotasLine}`);
    if (numFeePaid) out.push(`- Número de cuota(s): ${numFeePaid}`);
    if (unlockCode) out.push(`- Código de desbloqueo: ${unlockCode}`);
    if (lines.length) out.push(...lines);
    out.push(`Monto Total: ${PEN.format(total)}`);
    if (finalized) out.push(`Crédito Finalizado ✅`);

    return out.join("\n");
};

/* ===================== Formato de moneda (Perú - PEN) ===================== */
const PEN = new Intl.NumberFormat("es-PE", {
    style: "currency",
    currency: "PEN",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});

/* ===================== Helper: texto de método de pago online ===================== */
const getOnlinePayLabel = (v) => {
    const s = String(v ?? "0");
    if (s === "1") return "Yape";
    if (s === "2") return "Tarjeta";
    if (s === "3") return "Transferencia";
    if (s === "4") return "Culqi POS";
    if (s === "5") return "Culqi Yape";
    if (s === "6") return "Culqi Tarjeta";
    return "";
};

/* =========================== COMPONENTE =========================== */
function RegisterPage(props) {
    const {
        user,
        rol,
        sedeId: ctxSedeId,
        sedeName: ctxSedeName,
        sedeLocation: ctxSedeLocation,
    } = useAuth();

    useSedeGate({ user, rol });

    const formRef = useRef();

    // Preloader
    const [loading, setLoading] = useState(false);
    const activeRequestRef = useRef({ id: 0, key: "" });
    const requestAbortRef = useRef(null);
    const isMountedRef = useRef(true);

    // sedes catálogo
    const [sedesF, setSedesF] = useState();
    const [sedes, setSedes] = useState();
    const [fullName, setFullName] = useState(null);

    // phones select options
    const [phoneOptions, setPhoneOptions] = useState([]);

    // UI y filtros
    const [showListRegister, setShowListRegister] = useState(false);
    const [sedeID, setSedeID] = useState(null);
    const [sedeName, setSedeName] = useState("Todos");
    const [sedeLocation, setSedeLocation] = useState(
        "Se muestran todas las sedes",
    );
    const [multiData, setMultiData] = useState();
    const [sedesFilter, setSedesFilter] = useState([]);
    const [selectedSelect, setSelectedSelect] = useState(null);

    // FM
    const [showFmModal, setShowFmModal] = useState(false);
    const [pendingFormData, setPendingFormData] = useState(null);

    // Fechas
    const calendarInputRef = useRef(null);
    const [dateRange, setDateRange] = useState([]);
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();

    const TZ = "America/Lima";
    const fmt = (d) => (d ? moment(d).tz(TZ).format("YYYY-MM-DD") : null);

    const today = new Date();
    const formatToday = today.toLocaleDateString("es-ES", {
        weekday: "long",
        day: "numeric",
        month: "long",
    });
    const [showText, setShowText] = useState(`Mostrando "${formatToday}"`);

    // Advisors / registros
    const [advisors, setAdvisors] = useState([]);
    const [listRegister, setListRegister] = useState([]);
    const [allRegisters, setAllRegisters] = useState([]);
    const [renderLimit, setRenderLimit] = useState(220);
    const renderAnchorRef = useRef(null);
    const [selectedAdvisor, setSelectedAdvisor] = useState(null);

    const [allUsers, setAllUsers] = useState([]);

    // Video de validación de inicial en Registros
    const [initialVideoPopup, setInitialVideoPopup] = useState({
        open: false,
        data: null,
        loading: false,
        error: "",
    });

    // NUEVO: edición de registros
    const [editTarget, setEditTarget] = useState(null);

    // NUEVO: eliminación de registros
    const [deleteTarget, setDeleteTarget] = useState(null);
    const [deleting, setDeleting] = useState(false);
    const [deleteAnimateOut, setDeleteAnimateOut] = useState(false);

    // NUEVO: unlockCode (cuando se paga una cuota vencida - MovilesPay)
    const [unlockCode, setUnlockCode] = useState(null);
    const [showUnlockPopup, setShowUnlockPopup] = useState(false);
    const [unlockAnimateOut, setUnlockAnimateOut] = useState(false);

    // NUEVO: Popup de finalización (Pagar Todo - MovilesPay)
    const [payPopupTitle, setPayPopupTitle] = useState("");
    const [payPopupCuotas, setPayPopupCuotas] = useState("");
    const [payPopupFinalText, setPayPopupFinalText] = useState("");
    const [payPopupWasLocked, setPayPopupWasLocked] = useState(false);
    const [payPopupSummary, setPayPopupSummary] = useState(null);
    const [showFinalizePopup, setShowFinalizePopup] = useState(false);
    const [finalizeAnimateOut, setFinalizeAnimateOut] = useState(false);

    // ===================== Reprogramación (MovilesPay - Cuota) =====================
    const [showReschedulePopup, setShowReschedulePopup] = useState(false);
    const [rescheduleAnimateOut, setRescheduleAnimateOut] = useState(false);
    const [dayReschedule, setDayReschedule] = useState(null);
    const [rescheduleSelectIndex, setRescheduleSelectIndex] = useState(null);
    const rescheduleNumFeeRef = useRef(null);
    const [rescheduleCtx, setRescheduleCtx] = useState(null); // payload del row (dni, montos, etc.)
    const [rescheduleCredit, setRescheduleCredit] = useState(null); // creditData (id, daysPayment, paymentFrequency)
    const [rescheduleReviewStage, setRescheduleReviewStage] = useState(0);
    const [reschedulePreview, setReschedulePreview] = useState(null);

    const closeReschedulePopup = () => {
        setRescheduleAnimateOut(true);
        setTimeout(() => {
            setRescheduleAnimateOut(false);
            setShowReschedulePopup(false);
            setDayReschedule(null);
            setRescheduleSelectIndex(null);
            setRescheduleCtx(null);
            setRescheduleCredit(null);
            setRescheduleReviewStage(0);
            setReschedulePreview(null);
            if (rescheduleNumFeeRef.current) rescheduleNumFeeRef.current.value = "1";
        }, 480);
    };

    const doDayReschedule = (idx, dateStr) => {
        setRescheduleSelectIndex(idx);
        setDayReschedule(dateStr);
    };

    const rescheduleSavingRef = useRef(false);

    const openRescheduleFromRow = async (payload) => {
        // payload viene desde RegisterTableContadoCuota
        const dni = String(payload?.dni || "").trim();
        const pendingCount = Number(payload?.pendingCount || 0);

        if (!dni || dni.length !== 8) {
            toast.error("Ingrese un DNI válido antes de reprogramar.");
            return;
        }
        // Debe existir al menos 2 cuotas pendientes para poder reprogramar (se excluye la última)
        if (pendingCount <= 1) {
            toast.info("No hay suficientes cuotas pendientes para reprogramar.");
            return;
        }

        setRescheduleCtx(payload);
        setShowReschedulePopup(true);

        try {
            const resp = await axios({
                method: "POST",
                url: CREDIT_BY_DNI_URL,
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
                data: { dni },
                timeout: 30000,
            });

            const resData = resp?.data;
            const credit = resData?.data || resData?.credit || resData || null;
            if (!credit) throw new Error("No se pudo obtener el crédito.");
            const creditID = Number(credit?.fr_id || credit?.id || credit?.creditID);
            const paymentFrequency = String(
                credit?.fr_payment_frequency || credit?.paymentFrequency || "",
            ).trim();
            const daysPaymentRaw =
                credit?.fr_days_payment || credit?.daysPayment || "[]";
            const daysPayment = Array.isArray(daysPaymentRaw)
                ? daysPaymentRaw
                : JSON.parse(String(daysPaymentRaw || "[]"));

            setRescheduleCredit({
                creditID,
                paymentFrequency,
                daysPayment,
            });
        } catch (e) {
            console.error("openRescheduleFromRow error:", e);
            toast.error("No se pudo cargar el calendario del crédito.");
            closeReschedulePopup();
        }
    };

    const buildReschedulePlan = () => {
        if (!rescheduleCredit?.creditID) throw new Error("No se pudo identificar el crédito.");
        if (!dayReschedule) throw new Error("Seleccione el día para la reprogramación.");
        const schedule=Array.isArray(rescheduleCredit.daysPayment)?[...rescheduleCredit.daysPayment]:[];
        const paidBefore=schedule.filter(x=>String(x.state)==="1");
        const pending=schedule.filter(x=>String(x.state)==="0");
        const requested=Number(rescheduleCtx?.numFees||0);
        if(!requested||requested<=0) throw new Error("Número de cuotas inválido.");
        if(requested>=pending.length) throw new Error("No se puede reprogramar si el pago cancela todas las cuotas pendientes.");
        const frequency=String(rescheduleCredit.paymentFrequency||"").trim();
        const rules={Diario:{amount:1,unit:"days"},Semanal:{amount:7,unit:"days"},Quincenal:{amount:15,unit:"days"},Mensual:{amount:1,unit:"months"}};
        const rule=rules[frequency];
        if(!rule) throw new Error("El crédito no tiene una frecuencia válida.");
        const base=moment(dayReschedule,"DD-MM-YYYY",true);
        if(!base.isValid()) throw new Error("Fecha de reprogramación inválida.");

        const selected=pending.slice(0,requested);
        const normalPaid=selected.slice(0,-1);
        const pivot=selected[selected.length-1];
        const normalIds=new Set(normalPaid.map(x=>Number(x.id)));
        const pivotId=Number(pivot.id);
        const pivotIndex=pending.findIndex(x=>Number(x.id)===pivotId);

        const reprogrammedPending=pending.map((item,index)=>{
            const id=Number(item.id);
            if(normalIds.has(id)) return {...item,state:1}; // conserva fecha original
            if(id===pivotId) return {...item,date:base.format("DD/MM/YYYY"),state:1};
            if(index>pivotIndex){
                const offset=index-pivotIndex;
                return {...item,date:base.clone().add(offset*rule.amount,rule.unit).format("DD/MM/YYYY"),state:0};
            }
            return item;
        });
        const newDaysPayment=paidBefore.concat(reprogrammedPending);
        return {requested,frequency,normalPaid,pivot,pivotId,baseDate:dayReschedule,newDaysPayment,
            nextUnpaid:reprogrammedPending.find(x=>String(x.state)==="0")||null,pendingCount:pending.length};
    };

    const confirmReschedule = async () => {
        if(rescheduleSavingRef.current)return;
        let plan;
        try{plan=buildReschedulePlan();}catch(e){toast.error(e?.message||"No se pudo preparar la reprogramación.");return;}
        if(rescheduleReviewStage===0){setReschedulePreview(plan);setRescheduleReviewStage(1);return;}
        if(rescheduleReviewStage===1){setReschedulePreview(plan);setRescheduleReviewStage(2);return;}

        rescheduleSavingRef.current=true;
        try{
            setLoading(true);
            const baseForm={...formRef.current.getValues(),sedeID:isRole3?ctxSedeId:sedeID,numFees:plan.requested,num_fee_paid:plan.requested,
                isReschedule:"1",rescheduleSchedule:plan.newDaysPayment,rescheduleDate:plan.baseDate,
                rescheduleMeta:{frequency:plan.frequency,baseDate:plan.baseDate,paidCount:plan.requested,
                    normalPaidIds:plan.normalPaid.map(x=>Number(x.id)),rescheduledFeeId:Number(plan.pivot.id),
                    rescheduledFeeNumber:plan.pivot.id,previousPendingCount:plan.pendingCount,nextUnpaidDate:plan.nextUnpaid?.date||null}};
            await reallySaveRegister(baseForm,{silent:true,suppressPayPopup:true});

            const details=Array.isArray(rescheduleCtx?.paymentDetails)?rescheduleCtx.paymentDetails:[];
            const paymentLines=details.map(p=>{const v=parseMoneyPopup(p?.amount);if(!(v>0))return null;
                const m=String(p?.method??"0"),label=m==="0"?"Efectivo en tienda":(getOnlinePayLabel(m)||"Pago");
                return `Pago ${label}: ${PEN.format(v)}`;}).filter(Boolean);
            const total=parseMoneyPopup(rescheduleCtx?.cashAmount)+parseMoneyPopup(rescheduleCtx?.onlineAmount);
            const totalFees=plan.newDaysPayment.length,paidFees=plan.newDaysPayment.filter(x=>String(x.state)==="1").length;
            closeReschedulePopup();
            openFinalizePopup({title:"PAGO REPROGRAMADO",cuotas:"",finalText:"",wasLocked:false,summary:{
                headTitle:"PAGO REPROGRAMADO",title:"Cuota MóvilesPay",
                sedeName:String((isRole3?ctxSedeName||sedeName:sedeName)||"").trim(),
                customerName:`${rescheduleCtx?.name||""} ${rescheduleCtx?.paternalSur||""} ${rescheduleCtx?.maternalSur||""}`.replace(/\\s+/g," ").trim(),
                dni:String(rescheduleCtx?.dni||"").trim(),cuotasLine:totalFees?`Cuota ${paidFees}/${totalFees}`:"",
                numFeePaid:plan.requested,total,lines:[...plan.normalPaid.map(x=>`✓ Cuota N.º ${x.id}: pago normal`),
                    `↻ Cuota N.º ${plan.pivot.id}: pago + reprogramación`,...paymentLines],finalized:false,unlockCode:unlockCode||""}});
        }catch(e){console.error("confirmReschedule error:",e);toast.error(e?.response?.data?.error||e?.message||"No se guardó nada: falló pago + reprogramación.");}
        finally{setLoading(false);rescheduleSavingRef.current=false;}
    };

    const openFinalizePopup = ({
        title,
        cuotas,
        finalText,
        wasLocked,
        summary,
    }) => {
        setPayPopupTitle(String(title || "").trim());
        setPayPopupCuotas(String(cuotas || "").trim());
        setPayPopupFinalText(String(finalText || "").trim());
        setPayPopupWasLocked(Boolean(wasLocked));
        setPayPopupSummary(summary || null);
        setShowFinalizePopup(true);
    };

    const closeFinalizePopup = () => {
        setFinalizeAnimateOut(true);
        setTimeout(() => {
            setFinalizeAnimateOut(false);
            setShowFinalizePopup(false);

            setPayPopupTitle("");
            setPayPopupCuotas("");
            setPayPopupFinalText("");
            setPayPopupWasLocked(false);
            setPayPopupSummary(null);

            // Limpieza extra
            setUnlockCode(null);
        }, 480);
    };

    /* ===================== UI: Resumen de pago en popup (Cuota Payjoy / MóvilesPay) ===================== */
    const renderPayPopupSummary = (summary) => {
        if (!summary) return null;

        // const titleOne = String("PAGO REGISTRADO").trim();
        const headTitle = String(summary.headTitle || "PAGO REGISTRADO").trim();
        const title = String(summary.title || "").trim();
        const customerName = String(summary.customerName || "").trim();
        const dni = String(summary.dni || "").trim();
        const cuotasLine = String(summary.cuotasLine || "").trim();
        const numFeePaid =
            summary.numFeePaid != null ? String(summary.numFeePaid) : "";
        const unlockCode =
            summary.unlockCode != null ? String(summary.unlockCode).trim() : "";

        const total = Number(summary.total || 0);
        const lines = Array.isArray(summary.lines) ? summary.lines : [];
        const finalized = Boolean(summary.finalized);
        const sedeName = String(summary.sedeName || "").trim();

        const handleCopy = async () => {
            try {
                const text = buildWhatsappTextFromSummary(summary);
                if (!text) return;

                await navigator.clipboard.writeText(text);
                toast.success("Texto copiado. Pégalo en WhatsApp.", {
                    position: "top-right",
                    autoClose: 2200,
                });
            } catch (e) {
                console.error("copy error:", e);
                toast.error("No se pudo copiar. Intenta nuevamente.", {
                    position: "top-right",
                    autoClose: 2200,
                });
            }
        };

        return (
            <div
                onClick={handleCopy}
                title="Click para copiar y pegar en WhatsApp"
                role="button"
                style={{
                    border: "1px solid #d9d9d9",
                    background: "#fafafa",
                    borderRadius: 10,
                    padding: "12px 12px 12px 20px",
                    textAlign: "left",
                    cursor: "pointer",
                    userSelect: "none",
                    minWidth: 290,
                }}
            >
                {/* {!!(headTitle || title) && (
                    <div style={{ fontWeight: 800, marginBottom: 0 }}>{headTitle || title}</div>
                )} */}

                {headTitle && title && headTitle !== title && (
                    <div style={{ fontWeight: 800, marginBottom: 0 }}>{title}</div>
                )}

                {!!sedeName && (
                    <div style={{ fontWeight: 600, marginBottom: 0 }}>
                        Sede: {sedeName}
                    </div>
                )}

                {!!customerName && <div>{customerName}</div>}
                {!!dni && <div style={{ marginBottom: 0 }}>DNI: {dni}</div>}

                {!!cuotasLine && (
                    <div style={{ marginBottom: 0, fontWeight: 700 }}>{cuotasLine}</div>
                )}

                {!!numFeePaid && (
                    <div style={{ marginBottom: 0 }}>
                        Número de cuota(s): {numFeePaid}
                    </div>
                )}

                {!!unlockCode && (
                    <div style={{ marginBottom: 0 }}>
                        Código de desbloqueo: {unlockCode}
                    </div>
                )}

                {lines.length > 0 && (
                    <div style={{ marginTop: 0, lineHeight: 1.35 }}>
                        {lines.map((t, idx) => (
                            <div key={idx}>{t}</div>
                        ))}
                    </div>
                )}

                <div style={{ marginTop: 4, fontWeight: 500 }}>
                    Monto Total: {PEN.format(total)}
                </div>

                {finalized && (
                    <div style={{ marginTop: 10, fontWeight: 800 }}>
                        Crédito Finalizado ✅
                    </div>
                )}
            </div>
        );
    };

    const openUnlockPopup = (code) => {
        if (!code) return;
        setUnlockCode(code);
        setShowUnlockPopup(true);
    };

    const closeUnlockPopup = () => {
        setUnlockAnimateOut(true);
        setTimeout(() => {
            setUnlockAnimateOut(false);
            setShowUnlockPopup(false);
            setUnlockCode(null);
        }, 480);
    };

    const openDeleteModal = (row) => {
        if (rol !== "1") return;
        setDeleteTarget(row);
    };

    const closeDeleteModal = () => {
        if (deleting) return;
        setDeleteAnimateOut(true);
        setTimeout(() => {
            setDeleteAnimateOut(false);
            setDeleteTarget(null);
        }, 480);
    };

    const closeInitialVideoPopup = () => {
        setInitialVideoPopup({ open: false, data: null, loading: false, error: "" });
    };

    const openInitialVideoPopup = async (row) => {
        if (!row?.id) return;
        setInitialVideoPopup({
            open: true,
            data: row.initialValidationVideoUrl
                ? {
                    registerID: row.id,
                    dni: row.dni,
                    fullName: `${row.name || ""} ${row.paternalSur || ""} ${row.maternalSur || ""}`.replace(/\s+/g, " ").trim(),
                    initialAmount: Number(row.cashAmount || 0) + Number(row.onlineAmount || 0),
                    videoUrl: row.initialValidationVideoUrl,
                    videoName: row.initialValidationVideoName,
                    completedAt: row.initialValidationCompletedAt,
                }
                : null,
            loading: true,
            error: "",
        });
        try {
            const res = await axios.get(`${process.env.REACT_APP_API}/register/${row.id}/initial-validation-video`, {
                headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
                timeout: 30000,
            });
            if (res?.data?.msg !== "success") throw new Error(res?.data?.error || "No se pudo cargar el video.");
            setInitialVideoPopup({ open: true, data: res.data.data, loading: false, error: "" });
        } catch (error) {
            setInitialVideoPopup((prev) => ({
                ...prev,
                loading: false,
                error: error?.response?.data?.error || error?.message || "No se pudo cargar el video.",
            }));
        }
    };

    const openEditModal = (row) => {
        // Cat 3, 4 y 5 NO se pueden editar por ahora
        const catStr = String(row?.cat ?? "");
        if (["3", "4", "5"].includes(catStr)) {
            alert("Este tipo de registro aún no se puede editar.");
            return;
        }
        setEditTarget(row);
    };

    const closeEditModal = () => {
        setEditTarget(null);
    };

    // contadores
    const [typeCounts, setTypeCounts] = useState({
        payjoy: 0,
        movilespay: 0,
        efectiva: 0,
        credismart: 0,
        alo_credit: 0,
        contado: 0,
        egreso: 0,
        salida: 0,
        garantias: 0,
        totalEquipos: 0,
    });
    const [tipo, setTipo] = useState(null);

    const isRole3 = String(rol) === "3";

    const isRole15 = ["1", "5"].includes(String(rol));

    const displaySedeName = isRole3
        ? ctxSedeName || "Sede no seleccionada"
        : sedeName;
    const displaySedeLocation = isRole3 ? ctxSedeLocation || "" : sedeLocation;

    const firstWord = (s) => (s || "").trim().split(/\s+/)[0] || "";
    const keyId = (v) => String(v ?? "").trim();

    const [kpiSelected, setKpiSelected] = useState(null);
    const [actualRegCount, setActualRegCount] = useState(0);

    const CLICKABLE_KPIS = [
        "fm_payjoy",
        "pagos_fm_payjoy",
        "cuota_payjoy",
        "fm_credismart",
        "pagos_fm_credismart",
        "cuota_credismart",
        "fm_alo_credit",
        "pagos_fm_alo_credit",
        "cuota_alo_credit",
        "fm_movilespay",
        "pagos_fm_movilespay",
        "cuota_movilespay",
    ];

    const KPI_FILTERS = {
        fm_payjoy: (r) =>
            r.cat === 1 && r.subCat === 1 && r.segment === 1 && String(r.fm) === "1",
        pagos_fm_payjoy: (r) => r.cat === 2 && r.subCat === 6 && r.segment === 1,
        cuota_payjoy: (r) => r.cat === 2 && r.subCat === 2 && r.segment === 1,
        fm_credismart: (r) =>
            r.cat === 1 && r.subCat === 1 && r.segment === 4 && String(r.fm) === "1",
        pagos_fm_credismart: (r) =>
            r.cat === 2 && r.subCat === 6 && r.segment === 4,
        cuota_credismart: (r) => r.cat === 2 && r.subCat === 2 && r.segment === 4,
        fm_alo_credit: (r) =>
            r.cat === 1 && r.subCat === 1 && r.segment === 5 && String(r.fm) === "1",
        pagos_fm_alo_credit: (r) =>
            r.cat === 2 && r.subCat === 6 && r.segment === 5,
        cuota_alo_credit: (r) => r.cat === 2 && r.subCat === 2 && r.segment === 5,
        fm_movilespay: (r) =>
            r.cat === 1 && r.subCat === 1 && r.segment === 2 && String(r.fm) === "1",
        pagos_fm_movilespay: (r) =>
            r.cat === 2 && r.subCat === 6 && r.segment === 2,
        cuota_movilespay: (r) => r.cat === 2 && r.subCat === 2 && r.segment === 2,
    };

    const KPI_CARDS_ADMIN_BASE = [
        {
            key: "total_registros",
            title: "Total Registros",
            icon: "📦",
            isCount: true,
        },
        {
            key: "actual_registros",
            title: "Actual Registros",
            icon: "📊",
            isCount: true,
        },
        { key: "fm_payjoy", title: "FM PayJoy", icon: "💳" },
        { key: "pagos_fm_payjoy", title: "Pagos FM PayJoy", icon: "💵" },
        { key: "cuota_payjoy", title: "Cuota PayJoy", icon: "📈" },
        { key: "fm_credismart", title: "FM CrediSmart", icon: "💳" },
        { key: "pagos_fm_credismart", title: "Pagos FM CrediSmart", icon: "💵" },
        { key: "cuota_credismart", title: "Cuota CrediSmart", icon: "📈" },
        { key: "fm_alo_credit", title: "FM Alo Credit", icon: "💳" },
        { key: "pagos_fm_alo_credit", title: "Pagos FM Alo Credit", icon: "💵" },
        { key: "cuota_alo_credit", title: "Cuota Alo Credit", icon: "📈" },
        { key: "fm_movilespay", title: "FM MovilesPay", icon: "💳" },
        { key: "pagos_fm_movilespay", title: "Pagos FM MovilesPay", icon: "💵" },
        { key: "cuota_movilespay", title: "Cuota MovilesPay", icon: "📈" },
        { key: "ingreso_nivel_caja", title: "Ingreso Nivelación Caja", icon: "📥" },
        {
            key: "total_egreso_cash",
            title: "Total Egreso (cash)",
            icon: "🧾",
            danger: true,
        },
        {
            key: "total_salida_cash",
            title: "Total Retiro (cash)",
            icon: "🏧",
            danger: true,
        },
        {
            key: "total_ventas_acc_serv",
            title: "Ventas Acc./Servicios",
            icon: "🛠️",
        },
        { key: "total_ventas_celulares", title: "Ventas Celulares", icon: "📱" },
        { key: "cpc_payjoy", title: "CPC PayJoy", icon: "📌" },
        { key: "cpc_movilespay", title: "CPC MovilesPay", icon: "📌" },
        { key: "cpc_efectiva", title: "CPC Efectiva", icon: "📌" },
        { key: "cpc_credismart", title: "CPC CrediSmart", icon: "📌" },
        { key: "cpc_alo_credit", title: "CPC Alo Credit", icon: "📌" },
        { key: "cpc_culqi_pos", title: "Culqi POS", icon: "🧾" },
        { key: "monto_online", title: "Monto Online", icon: "💳" },
        { key: "total_efectivo", title: "Total Efectivo", icon: "🏦" },
        { key: "ingresos_globales", title: "Ingresos Globales", icon: "💰" },
    ];

    const KPI_CARDS_ADMIN = useMemo(() => {
        const base = Array.isArray(KPI_CARDS_ADMIN_BASE)
            ? [...KPI_CARDS_ADMIN_BASE]
            : [];
        if (!isRole15) return base;

        const idx = base.findIndex((c) => c.key === "total_efectivo");
        if (idx >= 0) {
            // Iniciales antes de Total Efectivo
            base.splice(idx, 0, { key: "iniciales", title: "Iniciales", icon: "💰" });
            // Total Efectivo de hoy después de Total Efectivo (queda en idx+2 por la inserción anterior)
            base.splice(idx + 2, 0, {
                key: "total_efectivo_hoy",
                // title: "Total Efectivo de hoy",
                title: "Monto de hoy",
                icon: "🏦",
            });
        } else {
            base.push({ key: "iniciales", title: "Iniciales", icon: "💰" });
            base.push({
                key: "total_efectivo_hoy",
                // title: "Total Efectivo de hoy",
                title: "Monto de hoy",
                icon: "🏦",
            });
        }

        return base;
    }, [isRole15]);

    const KPI_CARDS_SELLER = [
        { key: "fm_payjoy", title: "FM PayJoy", icon: "💳" },
        { key: "pagos_fm_payjoy", title: "Pagos FM PayJoy", icon: "💵" },
        { key: "cuota_payjoy", title: "Cuota PayJoy", icon: "📈" },
        { key: "fm_credismart", title: "FM CrediSmart", icon: "💳" },
        { key: "pagos_fm_credismart", title: "Pagos FM CrediSmart", icon: "💵" },
        { key: "cuota_credismart", title: "Cuota CrediSmart", icon: "📈" },
        { key: "fm_alo_credit", title: "FM Alo Credit", icon: "💳" },
        { key: "pagos_fm_alo_credit", title: "Pagos FM Alo Credit", icon: "💵" },
        { key: "cuota_alo_credit", title: "Cuota Alo Credit", icon: "📈" },
        { key: "fm_movilespay", title: "FM MovilesPay", icon: "💳" },
        { key: "pagos_fm_movilespay", title: "Pagos FM MovilesPay", icon: "💵" },
        { key: "cuota_movilespay", title: "Cuota MovilesPay", icon: "📈" },
        {
            key: "total_egreso_cash",
            title: "Total Egreso (cash)",
            icon: "🧾",
            danger: true,
        },
        {
            key: "total_salida_cash",
            title: "Total Salida (cash)",
            icon: "🏧",
            danger: true,
        },
        { key: "monto_online", title: "Monto Online", icon: "💳" },
        { key: "total_efectivo", title: "Total Efectivo", icon: "🏦" },
    ];

    const renderKpiGrid = (cards, kpisObj, opts = {}) => {
        if (!kpisObj) return null;

        const clickableKeys = opts.clickableKeys || [];
        const selectedKey = opts.selectedKey || null;
        const onClickKpi = opts.onClickKpi;

        return (
            <div
                className="salesSummary salesSummaryGrid"
                style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
                    gap: 9,
                }}
            >
                {cards.map((card) => {
                    const isCount = !!card.isCount;
                    const isNegative = !!card.danger;

                    const raw =
                        card.key === "actual_registros"
                            ? Number(actualRegCount || 0)
                            : Number(kpisObj[card.key] || 0);

                    let value;
                    if (isCount) {
                        value = raw;
                    } else {
                        const magnitude = Math.abs(raw);
                        const formatted = PEN.format(magnitude);
                        const sign = isNegative ? "-" : raw < 0 ? "-" : "";
                        value = `${sign}${formatted}`;
                    }

                    const isClickable =
                        clickableKeys.includes(card.key) &&
                        typeof onClickKpi === "function";
                    const isSelected = selectedKey === card.key;

                    return (
                        <div
                            key={card.key}
                            className={`summaryItem ${isNegative ? "negative" : ""} ${isClickable ? "clickable" : ""
                                } ${isSelected ? "selected" : ""}`}
                            onClick={isClickable ? () => onClickKpi(card.key) : undefined}
                            title={isClickable ? "Filtrar por este KPI" : undefined}
                            role={isClickable ? "button" : undefined}
                        >
                            <span className="summaryLabel">
                                {card.icon} {card.title}
                            </span>
                            <div
                                className="summaryValue"
                                style={{ color: isNegative ? "#d64545" : "#0b74ff" }}
                            >
                                {value}
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    };

    function handleAdminKpiClick(key) {
        if (kpiSelected === key) {
            setKpiSelected(null);
            setListRegister(allRegisters);
            setActualRegCount(allRegisters.length);
            return;
        }
        if (!CLICKABLE_KPIS.includes(key)) return;

        const pred = KPI_FILTERS[key];
        const filtered = (allRegisters || []).filter(pred);

        setKpiSelected(key);
        setListRegister(filtered);
        setActualRegCount(filtered.length);
    }

    /* =========================== API HELPERS =========================== */

    const deleteRegisterById = async (registerID) => {
        if (!registerID) return;
        setDeleting(true);

        const prevList = Array.isArray(listRegister) ? [...listRegister] : [];
        const prevAll = Array.isArray(allRegisters) ? [...allRegisters] : [];

        try {
            const url = `${process.env.REACT_APP_API}/register/${registerID}`;

            // Optimistic UI profesional
            setListRegister((prev) =>
                prev.filter((item) => Number(item.id) !== Number(registerID)),
            );
            setAllRegisters((prev) =>
                prev.filter((item) => Number(item.id) !== Number(registerID)),
            );
            setActualRegCount((prev) => Math.max(0, Number(prev || 0) - 1));

            // Se solicita confirmación solo cuando el backend detecte regalos.
            // La primera llamada no confirma la devolución física.
            const res = await axios.delete(url, {
                data: { confirmGiftReturn: false },
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
                timeout: 30000,
            });

            const data = res?.data || {};

            if (data.msg === "success") {
                toast.success("Registro eliminado correctamente.", {
                    position: "top-right",
                    autoClose: 3000,
                });

                // Re-sync real con backend para KPIs y consistencia
                await getFirstInfo(sedeID, fmt(startDate), fmt(endDate));
                return;
            }

            // rollback si backend no confirma
            setListRegister(prevList);
            setAllRegisters(prevAll);
            setActualRegCount(prevAll.length);

            alert(data.error || "No se pudo eliminar el registro.");
        } catch (error) {
            if (error?.response?.data?.code === "PROMO_PHYSICAL_RETURN_REQUIRED") {
                const confirmed = window.confirm(
                    "Esta venta tiene obsequios entregados. ¿Confirmas que TODOS fueron devueltos físicamente y están disponibles en la sede original? Se restaurará su stock."
                );
                if (confirmed) {
                    try {
                        await axios.delete(`${process.env.REACT_APP_API}/register/${registerID}`, {
                            data: { confirmGiftReturn: true },
                            headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
                            timeout: 30000,
                        });
                        toast.success("Venta eliminada y obsequios devueltos al inventario.");
                        await getFirstInfo(sedeID, fmt(startDate), fmt(endDate));
                        return;
                    } catch (retryError) { error = retryError; }
                } else {
                    error = new Error("Eliminación cancelada: falta confirmar devolución física.");
                }
            }
            console.error("Error al eliminar el registro:", error);
            setListRegister(prevList);
            setAllRegisters(prevAll);
            setActualRegCount(prevAll.length);
            alert(error?.response?.data?.error || error.message || "No se pudo eliminar el registro.");
        } finally {
            setDeleting(false);
            setDeleteTarget(null);
            setDeleteAnimateOut(false);
        }
    };

    const handleConfirmDelete = () => {
        if (!deleteTarget?.id || deleting) return;
        deleteRegisterById(deleteTarget.id);
    };

    const getSedes = async () => {
        try {
            const url = `${process.env.REACT_APP_API}/register/get-sedes-filter`;
            const token = localStorage.getItem("token");

            const response = await axios.get(url, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
                timeout: 30000,
            });

            const data = response.data;
            setSedesF(data.data || []);
        } catch (error) {
            console.error("Error al obtener las sedes:", error);
            alert(
                error.message ||
                "Ocurrió un error al cargar las sedes. Por favor, intenta nuevamente.",
            );
        }
    };

    const getAllUsers = async () => {
        try {
            const url = `${process.env.REACT_APP_API}/register/get-users-filter`;
            const token = localStorage.getItem("token");
            const res = await axios.get(url, {
                headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
            });
            setAllUsers(
                (res.data?.data || []).map((u) => ({
                    userID: u.idNumber,
                    nombre: u.nombre,
                    apellidoInicial: (u.apellidoPaterno || "").charAt(0).toUpperCase(),
                    rol: String(u.rol ?? u.rolId ?? u.role ?? ""),
                })),
            );
        } catch (e) {
            console.error("Error getAllUsers:", e);
        }
    };

    function countSalesByUser(records, filterUserID) {
        let filtered = records.filter(
            (r) => (r.cat === 1 || r.cat === 2) && r.subCat === 1,
        );
        if (filterUserID != null)
            filtered = filtered.filter((r) => r.userID === filterUserID);

        const countsMap = new Map();
        filtered.forEach((r) => {
            const id = r.userID;
            if (!countsMap.has(id)) {
                countsMap.set(id, {
                    userID: id,
                    nombre: r.userName,
                    apellidoInicial: r.userPaternalSur
                        ? r.userPaternalSur.charAt(0).toUpperCase()
                        : "",
                    sedeID: r.sedeID,
                    group: firstWord(r.sedeName),
                    records: 0,
                });
            }
            countsMap.get(id).records++;
        });

        return Array.from(countsMap.values())
            .sort((a, b) => b.records - a.records)
            .map((item, idx) => ({ index: idx + 1, ...item }));
    }

    const handleTipoClick = (newTipo) => {
        setTipo(newTipo);
        applyFilters({ tipo: newTipo, advisor: selectedAdvisor });
    };

    const handleAdvisorClick = (id) => {
        const idKey = keyId(id);
        const isSame = keyId(selectedAdvisor) === idKey;
        const next = isSame ? null : idKey;
        setSelectedAdvisor(next);
        setTipo("todos");
        applyFilters({ tipo: "todos", advisor: next });
    };

    function applyFilters({ tipo, advisor }) {
        const byAdvisor =
            advisor != null
                ? allRegisters.filter((r) => keyId(r.userID) === keyId(advisor))
                : allRegisters;

        const isWarrantyRegister = (r) =>
            Number(r.warranty_state || 0) > 0 || Number(r.warranty_id || 0) > 0;
        const validForSaleSummary = (r) =>
            ![2, 3].includes(Number(r.warranty_state || 0));
        const salesBase = byAdvisor.filter(validForSaleSummary);

        setTypeCounts({
            payjoy: salesBase.filter(
                (r) => r.cat === 1 && r.subCat === 1 && r.segment === 1,
            ).length,
            movilespay: salesBase.filter(
                (r) => r.cat === 1 && r.subCat === 1 && r.segment === 2,
            ).length,
            efectiva: salesBase.filter(
                (r) => r.cat === 1 && r.subCat === 1 && r.segment === 3,
            ).length,
            credismart: salesBase.filter(
                (r) => r.cat === 1 && r.subCat === 1 && r.segment === 4,
            ).length,
            alo_credit: salesBase.filter(
                (r) => r.cat === 1 && r.subCat === 1 && r.segment === 5,
            ).length,
            contado: salesBase.filter((r) => r.cat === 2 && r.subCat === 1).length,
            egreso: salesBase.filter((r) => r.cat === 3).length,
            salida: salesBase.filter((r) => r.cat === 5).length,
            garantias: byAdvisor.filter(isWarrantyRegister).length,
            totalEquipos: salesBase.filter(
                (r) => (r.cat === 1 || r.cat === 2) && r.subCat === 1,
            ).length,
        });

        let listaFinal = byAdvisor;
        switch (tipo) {
            case "payjoy":
                listaFinal = salesBase.filter(
                    (r) => r.cat === 1 && r.subCat === 1 && r.segment === 1,
                );
                break;
            case "movilespay":
                listaFinal = salesBase.filter(
                    (r) => r.cat === 1 && r.subCat === 1 && r.segment === 2,
                );
                break;
            case "efectiva":
                listaFinal = salesBase.filter(
                    (r) => r.cat === 1 && r.subCat === 1 && r.segment === 3,
                );
                break;
            case "credismart":
                listaFinal = salesBase.filter(
                    (r) => r.cat === 1 && r.subCat === 1 && r.segment === 4,
                );
                break;
            case "alo_credit":
                listaFinal = salesBase.filter(
                    (r) => r.cat === 1 && r.subCat === 1 && r.segment === 5,
                );
                break;
            case "contado":
                listaFinal = salesBase.filter((r) => r.cat === 2 && r.subCat === 1);
                break;
            case "egreso":
                listaFinal = salesBase.filter((r) => r.cat === 3);
                break;
            case "salida":
                listaFinal = salesBase.filter((r) => r.cat === 5);
                break;
            case "garantias":
                listaFinal = byAdvisor.filter(isWarrantyRegister);
                break;
            case "todos":
            default:
                break;
        }
        setListRegister(listaFinal);
    }

    const [totalEquipos, setTotalEquipos] = useState(0);
    const [usersWithNoSales, setUsersWithNoSales] = useState([]);

    const normalizeRegisters = (items = []) => {
        const uniqueById = new Map();

        (Array.isArray(items) ? items : [])
            .filter((item) => Number(item?.state ?? 1) === 1 || item?.state == null)
            .forEach((item) => {
                const normalized = {
                    ...item,
                    id: Number(item?.id ?? 0),
                    userID: Number(item?.userID ?? 0),
                    sedeID: Number(item?.sedeID ?? 0),
                    cat: Number(item?.cat ?? 0),
                    subCat: Number(item?.subCat ?? 0),
                    segment: Number(item?.segment ?? 0),
                    warranty_state: Number(
                        item?.warranty_state ?? item?.warrantyState ?? 0,
                    ),
                    warranty_id: Number(item?.warranty_id ?? item?.warrantyID ?? 0),
                };

                const key = normalized.id || `${normalized.dni}-${normalized.imei}-${normalized.creationDate || normalized.creation_date || ""}`;
                if (!uniqueById.has(key)) uniqueById.set(key, normalized);
            });

        return Array.from(uniqueById.values());
    };

    const downloadRegisterTicket = async (register, receiptDocument = null) => {
        const registerId = Number(register?.id || 0);
        const documentId = Number(receiptDocument?.id || 0);
        if (!registerId) {
            toast.error("No se pudo identificar la venta para descargar el Ticket.");
            return;
        }

        try {
            const endpoint = documentId
                ? `${process.env.REACT_APP_API}/inventory/sale-receipts/${documentId}/ticket`
                : `${process.env.REACT_APP_API}/register/${registerId}/ticket`;
            const response = await axios.get(endpoint, {
                headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
                responseType: "blob",
                timeout: 60000,
            });

            const disposition = String(response.headers?.["content-disposition"] || "");
            const match = disposition.match(/filename="?([^";]+)"?/i);
            const fallbackNumber = receiptDocument?.fullNumber || register?.electronicDocumentNumber || `registro-${registerId}`;
            const filename = match?.[1] || `${fallbackNumber}-ticket.pdf`;
            const url = window.URL.createObjectURL(response.data);
            const anchor = document.createElement("a");
            anchor.href = url;
            anchor.download = filename;
            document.body.appendChild(anchor);
            anchor.click();
            anchor.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            toast.error(error?.response?.data?.error || "No se pudo descargar el Ticket.");
        }
    };

    const getFirstInfo = async (sedeIDParam, f1, f2) => {
        const requestKey = JSON.stringify({
            sedeIDParam: sedeIDParam ?? null,
            f1: f1 || null,
            f2: f2 || null,
        });

        if (activeRequestRef.current.key === requestKey && loading) {
            return;
        }

        activeRequestRef.current.id += 1;
        activeRequestRef.current.key = requestKey;
        const currentRequestId = activeRequestRef.current.id;

        if (requestAbortRef.current) {
            requestAbortRef.current.abort();
        }

        const controller = new AbortController();
        requestAbortRef.current = controller;
        setLoading(true);

        try {
            const url = `${process.env.REACT_APP_API}/registers`;

            const response = await axios.get(url, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
                params: {
                    sedeID: sedeIDParam,
                    fechaInicio: f1 || null,
                    fechaFin: f2 || null,
                },
                signal: controller.signal,
                timeout: 45000,
            });

            if (
                !isMountedRef.current ||
                currentRequestId !== activeRequestRef.current.id
            ) {
                return;
            }

            const data = response?.data || {};

            const fullName = data.fullName;
            // const registers = normalizeRegisters(data.registers || []);
            const registers = normalizeRegisters(data.registers || []).filter(
                (r) => Number(r?.state ?? 1) === 1 || r?.state == null,
            );
            const sedes = data.sedes || [];
            const getUsersWithNoSales = data.usersWithNoSales || [];
            const nextMultiData = data.multiData || {};
            const resumenVentas = nextMultiData.resumenVentas || {};

            setFullName(fullName);
            setAllRegisters(registers);
            setUsersWithNoSales(getUsersWithNoSales);
            setAdvisors(countSalesByUser(registers));

            try {
                if (!getUsersWithNoSales || getUsersWithNoSales.length === 0) {
                    const soldIds = new Set(
                        registers
                            .filter((r) => (r.cat === 1 || r.cat === 2) && r.subCat === 1)
                            .map((r) => r.userID),
                    );
                    const zeroList = (allUsers || [])
                        .filter((u) => !soldIds.has(u.userID))
                        .map((u) => ({
                            userID: u.userID,
                            nombre: u.nombre,
                            apellidoInicial:
                                u.apellidoInicial || (u.nombre?.[0] || "").toUpperCase(),
                            rol: u.rol,
                            records: 0,
                        }));
                    setUsersWithNoSales(zeroList);
                } else {
                    setUsersWithNoSales(getUsersWithNoSales);
                }
            } catch (e) {
                console.error("calc no-sales error:", e);
            }

            setListRegister(registers);
            setRenderLimit(220);
            setKpiSelected(null);
            setActualRegCount(registers.length);
            setMultiData(nextMultiData);

            const totalEquiposNum =
                Number(resumenVentas.payjoy || 0) +
                Number(resumenVentas.movilespay || 0) +
                Number(resumenVentas.efectiva || 0) +
                Number(resumenVentas.credismart || 0) +
                Number(resumenVentas.alo_credit || 0) +
                Number(resumenVentas.contado || 0);

            setTotalEquipos(totalEquiposNum);

            setTypeCounts({
                payjoy: Number(resumenVentas.payjoy || 0),
                movilespay: Number(resumenVentas.movilespay || 0),
                efectiva: Number(resumenVentas.efectiva || 0),
                credismart: Number(resumenVentas.credismart || 0),
                alo_credit: Number(resumenVentas.alo_credit || 0),
                contado: Number(resumenVentas.contado || 0),
                egreso: Number(resumenVentas.egreso || 0),
                salida: Number(resumenVentas.salida || 0),
                // Garantías
                garantias: Number(resumenVentas.garantias || 0),
                totalEquipos: totalEquiposNum,
            });

            setSedes(sedes || []);

            const groupedOptions = buildGroupedSedesOptions(
                sedes || [],
                totalEquiposNum,
            );
            setSedesFilter(groupedOptions);

            const findOptionInGrouped = (opts, value) => {
                const v = String(value);
                for (const item of opts || []) {
                    if (item?.options && Array.isArray(item.options)) {
                        const hit = item.options.find((o) => String(o?.value) === v);
                        if (hit) return hit;
                    } else if (String(item?.value) === v) {
                        return item;
                    }
                }
                return null;
            };

            const isTodos = !sedeIDParam || Number(sedeIDParam) === 0;

            if (isTodos) {
                const allOption = findOptionInGrouped(groupedOptions, 0);
                if (allOption) {
                    setSelectedSelect(allOption);
                    setSedeID(0);
                    setSedeName("Todos");
                    setSedeLocation("Se muestran todas las sedes");
                }
            } else {
                const current = findOptionInGrouped(groupedOptions, sedeIDParam);

                if (current) setSelectedSelect(current);
            }
        } catch (error) {
            const isCanceled =
                error?.name === "CanceledError" ||
                error?.code === "ERR_CANCELED" ||
                axios.isCancel?.(error);

            if (isCanceled) return;

            console.error("Error al obtener los registros:", error);
            alert(
                error.message ||
                "Ocurrió un error al cargar los registros. Por favor, intenta nuevamente.",
            );
        } finally {
            if (currentRequestId === activeRequestRef.current.id) {
                setLoading(false);
            }
        }
    };

    const fetchPhones = async () => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API}/list-phones`,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                },
            );

            const adaptedOptions = response.data.data.map((phone) => ({
                value: phone.value,
                label: phone.label,
            }));

            setPhoneOptions(adaptedOptions);
        } catch (error) {
            console.error("Error al obtener la lista de celulares:", error);
        }
    };

    /* =========================== UI: TABLAS DINÁMICAS =========================== */

    const [componentList, setComponentList] = useState([]);
    const [showButtonAdd, setShowButtonAdd] = useState(true);
    const [wizardRegisterActive, setWizardRegisterActive] = useState(false);

    const egresoLoaded = useRef(false);

    const changeCat = (data) => {
        const { cat } = data;
        let registerTable = document.querySelector(".containerListRegister > .registerTable.registerTableInList");
        limpiarClasesRegisterTable(registerTable);

        if (cat === "1") {
            contadoOthersLoaded.current = false;
            egresoLoaded.current = false;
            setComponentList([
                <RegisterTableCredito
                    key={Date.now()}
                    options={phoneOptions}
                    onSendDataCat={changeCat}
                    onSendDataSubCat={changeSubCat}
                    onSendDataSegment={changeSegment}
                    ref={formRef}
                />,
            ]);
        } else if (cat === "2") {
            contadoOthersLoaded.current = false;
            egresoLoaded.current = false;
            setComponentList([
                <RegisterTableContado
                    key={Date.now()}
                    options={phoneOptions}
                    onSendDataCat={changeCat}
                    onSendDataSubCat={changeSubCat}
                    onSendDataSegment={changeSegment}
                    ref={formRef}
                />,
            ]);
        } else if (cat === "3") {
            contadoOthersLoaded.current = false;
            if (!egresoLoaded.current) {
                setComponentList([
                    <RegisterTableEgreso
                        key={Date.now()}
                        options={phoneOptions}
                        onSendDataCat={changeCat}
                        onSendDataSubCat={changeSubCat}
                        onSendDataSegment={changeSegment}
                        ref={formRef}
                    />,
                ]);
                egresoLoaded.current = true;
            }
        } else if (cat === "4") {
            contadoOthersLoaded.current = false;
            egresoLoaded.current = false;
            setComponentList([
                <RegisterTableIngreso
                    key={Date.now()}
                    options={phoneOptions}
                    onSendDataCat={changeCat}
                    onSendDataSubCat={changeSubCat}
                    onSendDataSegment={changeSegment}
                    ref={formRef}
                />,
            ]);
        } else if (cat === "5") {
            contadoOthersLoaded.current = false;
            egresoLoaded.current = false;
            setComponentList([
                <RegisterTableRetiro
                    key={Date.now()}
                    options={phoneOptions}
                    onSendDataCat={changeCat}
                    onSendDataSubCat={changeSubCat}
                    onSendDataSegment={changeSegment}
                    ref={formRef}
                />,
            ]);
        }
    };

    const contadoOthersLoaded = useRef(false);
    const changeSubCat = (data) => {
        const { cat, subCat, segment } = data;
        setWizardRegisterActive(false);
        let registerTable = document.querySelector(".containerListRegister > .registerTable.registerTableInList");
        limpiarClasesRegisterTable(registerTable);

        if (cat === "2" && subCat === "1" && segment !== "4") {
            contadoOthersLoaded.current = false;
            egresoLoaded.current = false;
            setComponentList([
                <RegisterTableContado
                    key={Date.now()}
                    options={phoneOptions}
                    onSendDataCat={changeCat}
                    onSendDataSubCat={changeSubCat}
                    onSendDataSegment={changeSegment}
                    ref={formRef}
                />,
            ]);
        } else if (cat === "2" && subCat === "2") {
            contadoOthersLoaded.current = false;
            egresoLoaded.current = false;

            if (segment === "2") {
                registerTable?.classList?.add("registerTable5");
            } else {
                registerTable?.classList?.add("registerTable6");
            }

            setWizardRegisterActive(true);
            setComponentList([
                <PaymentRegistrationWizard
                    key={`cuota-${Date.now()}`}
                    type="cuota"
                    onRescheduleRequested={openRescheduleFromRow}
                    onSaveRequested={addRegister}
                    onSendDataCat={changeCat}
                    onSendDataSubCat={changeSubCat}
                    onSendDataSegment={changeSegment}
                    ref={formRef}
                />,
            ]);
        } else if (cat === "2" && subCat === "4" && segment !== "4") {
            contadoOthersLoaded.current = false;
            registerTable?.classList?.add("registerTable7");
            setComponentList([
                <RegisterTableContadoFormateo
                    key={Date.now()}
                    options={phoneOptions}
                    onSendDataCat={changeCat}
                    onSendDataSubCat={changeSubCat}
                    onSendDataSegment={changeSegment}
                    ref={formRef}
                />,
            ]);
        } else if (cat === "2" && ["3", "5"].includes(subCat) && segment !== "4") {
            egresoLoaded.current = false;

            if (subCat === "3") {
                registerTable?.classList?.add("registerTable8");
            } else if (subCat === "5") {
                registerTable?.classList?.add("registerTable9");
            }

            if (!contadoOthersLoaded.current) {
                setComponentList([
                    <RegisterTableContadoOthers
                        key={Date.now()}
                        options={phoneOptions}
                        onSendDataCat={changeCat}
                        onSendDataSubCat={changeSubCat}
                        onSendDataSegment={changeSegment}
                        ref={formRef}
                        sendSubCat={subCat}
                    />,
                ]);
                contadoOthersLoaded.current = true;
            }
        } else if (cat === "2" && subCat === "6") {
            contadoOthersLoaded.current = false;
            egresoLoaded.current = false;

            if (segment === "1" || segment === "4") {
                registerTable?.classList?.add("registerTable11");
            } else if (segment === "2") registerTable?.classList?.add("registerTable5");

            setWizardRegisterActive(true);
            setComponentList([
                <PaymentRegistrationWizard
                    key={`fm-${Date.now()}`}
                    type="fm"
                    onSaveRequested={addRegister}
                    onSendDataCat={changeCat}
                    onSendDataSubCat={changeSubCat}
                    onSendDataSegment={changeSegment}
                    ref={formRef}
                />,
            ]);
        } else {
            contadoOthersLoaded.current = false;
            egresoLoaded.current = false;
        }
    };

    const changeSegment = (data) => {
        const { cat, subCat, segment } = data;
        let registerTable = document.querySelector(".containerListRegister > .registerTable.registerTableInList");

        registerTable?.classList?.remove(
            "registerTable1",
            "registerTable2",
            "registerTable3",
            "registerTable20",
            "registerTable21",
            "registerTable22",
            "registerTable30",
            "registerTable31",
            "registerTable5",
            "registerTable6",
        );

        if (cat === "1" && subCat === "1" && segment === "1") {
            registerTable?.classList?.add("registerTable1");
        } else if (cat === "1" && subCat === "1" && segment === "2") {
            registerTable?.classList?.add("registerTable2");
        } else if (cat === "1" && subCat === "1" && segment === "3") {
            registerTable?.classList?.add("registerTable3");
        } else if (cat === "1" && subCat === "1" && segment === "4") {
            registerTable?.classList?.add("registerTable20");
        } else if (cat === "1" && subCat === "1" && segment === "5") {
            registerTable?.classList?.add("registerTable30");
        } else if (cat === "2" && subCat === "2") {
            registerTable?.classList?.remove("registerTable5", "registerTable6", "registerTable21");
            if (segment === "1") {
                registerTable?.classList?.add("registerTable6");
            } else if (segment === "2") {
                registerTable?.classList?.add("registerTable5");
            } else if (segment === "5") {
                registerTable?.classList?.add("registerTable31");
            } else {
                registerTable?.classList?.add("registerTable21");
            }
        } else if (cat === "2" && subCat === "6") {
            registerTable?.classList?.remove("registerTable5", "registerTable11");
            if (segment === "1" || segment === "4") {
                registerTable?.classList?.add("registerTable21");
            } else if (segment === "2") {
                registerTable?.classList?.add("registerTable5");
            } else if (segment === "5") {
                registerTable?.classList?.add("registerTable31");
            }
        }
    };

    const addComponent = () => {
        setWizardRegisterActive(false);
        setShowButtonAdd(false);
        setComponentList([
            <RegisterTableCredito
                key={Date.now()}
                options={phoneOptions}
                onSendDataCat={changeCat}
                onSendDataSubCat={changeSubCat}
                onSendDataSegment={changeSegment}
                ref={formRef}
            />,
        ]);
    };

    const [paymentInfoMsg, setPaymentInfoMsg] = useState(null);
    const reallySaveRegister = async (formData, opts = {}) => {
        const { silent = false, suppressPayPopup = false, onSuccess = null } = opts;
        const pathApi = process.env.REACT_APP_API + "/register/add";
        setLoading(true);
        let msgFront = "Registrado con éxito.";

        // Helper: normaliza warnings a array de strings
        const normalizeWarnings = (raw) => {
            if (!raw) return [];
            if (Array.isArray(raw)) {
                return raw
                    .map((x) => (x == null ? "" : String(x).trim()))
                    .filter(Boolean);
            }
            if (typeof raw === "object") {
                // Por si backend manda {message, code} o cosas así
                try {
                    const str = raw?.message
                        ? String(raw.message).trim()
                        : JSON.stringify(raw);
                    return str ? [str] : [];
                } catch {
                    return [];
                }
            }
            const s = String(raw).trim();
            return s ? [s] : [];
        };

        // Helper: extrae warnings desde varios nombres posibles
        const pickNuovoWarnings = (data) => {
            if (!data) return [];
            return normalizeWarnings(
                data?.nuovoWarnings ??
                data?.nuovo_warnings ??
                data?.warnings ??
                data?.nuovoWarning ??
                null,
            );
        };

        try {
            const { wizardCompleted, ...payloadToSave } = formData || {};
            const response = await axios({
                method: "POST",
                url: pathApi,
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
                data: payloadToSave,
                timeout: 30000,
            });

            const resData = response.data;

            // Mensaje informativo devuelto por backend para pagos de cuotas (ej: "Cuota 7-10/10")
            const paymentInfoMsg =
                resData?.paymentInfoMsg ||
                resData?.payment_info_msg ||
                resData?.paymentMsg ||
                null;

            setPaymentInfoMsg(paymentInfoMsg);

            // ✅ NUEVO: warnings informativos de NuovoPay (NO deben tumbar flujo)
            const nuovoWarnings = pickNuovoWarnings(resData);

            if (resData.msg === "success") {
                setComponentList([]);
                setWizardRegisterActive(false);
                setListRegister(resData.registers);
                setMultiData(resData.multiData);
                setShowButtonAdd(true);

                if (typeof onSuccess === "function") {
                    try {
                        onSuccess(resData);
                    } catch (e) {
                        console.error("onSuccess error:", e);
                    }
                }

                // Guardar unlockCode/statusLock (si aplica) y mostrar en el mismo popup de pago
                const wasLocked = Boolean(resData?.statusLock);
                const code = resData?.unlockCode || null;

                setUnlockCode(code);

                // Detectar si el pago terminó el crédito (Pagar Todo o última cuota)
                const finalized =
                    Boolean(resData.contractFinalized) ||
                    Boolean(resData.creditFinalized) ||
                    Boolean(resData.creditFinished) ||
                    Boolean(resData.finalized) ||
                    Boolean(resData.payAllFinalized) ||
                    Boolean(resData.unregisteredNuovo) ||
                    Boolean(resData.nuovoUnregistered);

                // Texto final de finalización (solo si finaliza)
                const finalizedMsg =
                    resData?.contractFinalizedMsg ||
                    resData?.contract_finalized_msg ||
                    "Desinstalar App de seguridad, Pago total confirmado. Contrato finalizado..";

                // La línea de cuotas viene del backend como: 'Cuota 8-9-10/10' o 'Cuota 10/10'
                const cuotasLine = paymentInfoMsg ? String(paymentInfoMsg).trim() : "";

                // ===== Fallback para FM si backend no manda paymentInfoMsg =====
                const fmFeePaidRaw =
                    resData?.num_fee_paid ?? resData?.fm_num_fee_paid ?? null;
                const fmFeePaid =
                    fmFeePaidRaw != null
                        ? Number(fmFeePaidRaw)
                        : Number(formData?.numFees ?? 0);

                const cuotasLineFmFallback =
                    String(formData?.cat) === "2" &&
                        String(formData?.subCat) === "6" &&
                        !cuotasLine &&
                        fmFeePaid > 0
                        ? `Número de cuota(s): ${fmFeePaid}`
                        : "";

                // ===== Resumen de pago (solo para Contado -> Cuota -> Payjoy / MovilesPay) =====
                const isContadoCuotaAny =
                    String(formData?.cat) === "2" && String(formData?.subCat) === "2";

                const isContadoFmAny =
                    String(formData?.cat) === "2" && String(formData?.subCat) === "6";

                const isMovilesPayFm =
                    isContadoFmAny && String(formData?.segment) === "2";
                const isPayjoyFm = isContadoFmAny && String(formData?.segment) === "1";
                const isCrediSmartFm = isContadoFmAny && String(formData?.segment) === "4";
                const isAloCreditFm = isContadoFmAny && String(formData?.segment) === "5";

                const isPayjoyOrMovilesPay = ["1", "2", "4", "5"].includes(
                    String(formData?.segment),
                );

                const fmFinalized =
                    Boolean(resData?.fmFinalized) ||
                    Boolean(resData?.fmFinished) ||
                    false;

                const fmFinalizedMsg =
                    resData?.fmFinalizedMsg ||
                    resData?.fm_finalized_msg ||
                    "FM finalizado. Pago total confirmado.";

                const isPayjoyCuota =
                    isContadoCuotaAny && String(formData?.segment) === "1";
                const isCrediSmartCuota =
                    isContadoCuotaAny && String(formData?.segment) === "4";
                const isAloCreditCuota =
                    isContadoCuotaAny && String(formData?.segment) === "5";
                const isMovilesPayCuota =
                    isContadoCuotaAny && String(formData?.segment) === "2";

                const getNumFeesPaidForPopup = () => {
                    const raw = formData?.numFees;

                    // 1) Si el usuario eligió un número (1,2,3...) úsalo SIEMPRE
                    const n = Number(raw);
                    if (Number.isFinite(n) && n > 0) return n;

                    // 2) Si eligió ALL, intenta leer del backend (si lo devuelve)
                    const all = String(raw || "").toUpperCase() === "ALL";
                    if (all) {
                        const backendN = Number(
                            resData?.num_fee_paid ??
                            resData?.fm_num_fee_paid ??
                            resData?.feesPaid ??
                            0,
                        );
                        return backendN > 0 ? backendN : "ALL";
                    }

                    // 3) Fallback final: backend (pero solo si es > 0)
                    const backendN = Number(
                        resData?.num_fee_paid ?? resData?.fm_num_fee_paid ?? 0,
                    );
                    return backendN > 0 ? backendN : null;
                };

                const buildPaySummary = () => {
                    const n = String(formData?.name || "").trim();
                    const p = String(formData?.paternalSur || "").trim();
                    const m = String(formData?.maternalSur || "").trim();
                    const customerName = [n, p, m].filter(Boolean).join(" ").trim();

                    const dni = String(formData?.dni || "").trim();
                    const numFeePaid = getNumFeesPaidForPopup();

                    // ✅ SOLO POPUP: parseo correcto (150.00 => 150, no 15000)
                    const cash = parseMoneyPopup(formData?.cashAmount);
                    const online = parseMoneyPopup(formData?.onlineAmount);
                    const total = cash + online;

                    const details = Array.isArray(formData?.paymentDetails) ? formData.paymentDetails : [];
                    const lines = details.length ? details.map((p) => {
                        const amountDetail = parseMoneyPopup(p?.amount);
                        if (!(amountDetail > 0)) return null;
                        const method = String(p?.method ?? "0");
                        const label = method === "0" ? "Efectivo en tienda" : (getOnlinePayLabel(method) || "Pago");
                        return `Pago ${label}: ${PEN.format(amountDetail)}`;
                    }).filter(Boolean) : [];
                    if (!lines.length) {
                        if (cash > 0) lines.push(`Pago Efectivo en tienda: ${PEN.format(cash)}`);
                        if (online > 0) {
                            const label = getOnlinePayLabel(formData?.onlinePay);
                            lines.push(`Pago ${label || "Online"}: ${PEN.format(online)}`);
                        }
                    }

                    const title = isPayjoyCuota
                        ? "Cuota Payjoy"
                        : isCrediSmartCuota
                            ? "Cuota CrediSmart"
                            : isAloCreditCuota
                                ? "Cuota Alo Credit"
                                : isMovilesPayCuota
                                    ? "Cuota MóvilesPay"
                                    : isMovilesPayFm
                                        ? "Cuota FM MóvilesPay"
                                        : isPayjoyFm
                                            ? "Cuota FM Payjoy"
                                            : isCrediSmartFm
                                                ? "Cuota FM CrediSmart"
                                                : isAloCreditFm
                                                    ? "Cuota FM Alo Credit"
                                                    : "Pago registrado";

                    return {
                        headTitle: finalized
                            ? "CRÉDITO FINALIZADO"
                            : fmFinalized
                                ? "PAGO FM FINALIZADO"
                                : "PAGO REGISTRADO",
                        title,
                        sedeName: String(resData?.registers?.[0]?.sedeName || "").trim(),
                        customerName,
                        dni,
                        cuotasLine,
                        numFeePaid,
                        unlockCode: code != null ? String(code).trim() : "",
                        total,
                        lines,
                        finalized: Boolean(finalized),

                        // ✅ NUEVO: warnings para que tu popup (si lo deseas) pueda listarlos
                        nuovoWarnings: Array.isArray(nuovoWarnings) ? nuovoWarnings : [],
                    };
                };

                // Reglas de popup
                const isFmAny = isContadoFmAny && isPayjoyOrMovilesPay;

                // Para FM: abre popup si hay finalización, o si hay info de pago (paymentInfoMsg o fallback),
                // o si el usuario eligió pagar ALL
                const fmHasPaymentInfo =
                    Boolean(cuotasLine) || Boolean(cuotasLineFmFallback) || fmFeePaid > 0;
                const fmIsPayAll =
                    String(formData?.numFees || "").toUpperCase() === "ALL";

                const shouldOpenPayPopup =
                    ((isPayjoyCuota || isCrediSmartCuota || isAloCreditCuota) ? true : false) ||
                    ((isPayjoyFm || isCrediSmartFm || isAloCreditFm) ? true : false) ||
                    (isMovilesPayCuota &&
                        (finalized || cuotasLine || (wasLocked && code))) ||
                    (isMovilesPayFm && (fmFinalized || cuotasLine)) ||
                    // ✅ NUEVO: si hay warnings de NuovoPay, también conviene mostrar popup si ya iba a mostrarse,
                    // o al menos informarlo via toast (lo haremos abajo)
                    false;

                // ✅ NUEVO: construimos un bloque de warnings (texto) para adjuntar al popup si se abre
                const warningsText =
                    nuovoWarnings.length > 0
                        ? `\n\n⚠️ Avisos (NuovoPay):\n- ${nuovoWarnings.join("\n- ")}`
                        : "";

                if (!suppressPayPopup && shouldOpenPayPopup) {
                    openFinalizePopup({
                        title: finalized
                            ? "CRÉDITO FINALIZADO"
                            : fmFinalized
                                ? "PAGO FM FINALIZADO"
                                : "PAGO REGISTRADO",
                        cuotas: cuotasLine,
                        finalText: finalized
                            ? String(finalizedMsg).trim() + warningsText
                            : fmFinalized
                                ? String(fmFinalizedMsg).trim() + warningsText
                                : warningsText.trim(), // si no finaliza, igual mostramos warnings si existen
                        wasLocked,
                        summary: buildPaySummary(),
                    });
                } else {
                    // Si no hay popup, igual informamos warnings via toast (si aplica)
                    if (!silent && nuovoWarnings.length > 0) {
                        toast.warning(`Aviso NuovoPay: ${nuovoWarnings[0]}`, {
                            position: "top-right",
                            autoClose: 7000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            theme: "colored",
                        });
                    }
                }

                // Toast de éxito
                if (!silent) {
                    toast.success(msgFront, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored",
                    });

                    // ✅ NUEVO: si hubo warnings, mostramos un warning adicional (no bloqueante)
                    if (nuovoWarnings.length > 0) {
                        toast.warning(`Aviso NuovoPay: ${nuovoWarnings.join(" | ")}`, {
                            position: "top-right",
                            autoClose: 8000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            theme: "colored",
                        });
                    }
                } else {
                    if (nuovoWarnings.length > 0)
                        console.warn("[NuovoPay warnings]", nuovoWarnings);
                }

                return resData;
            }

            throw new Error(resData?.error || "El backend no confirmó el registro.");
        } catch (error) {
            console.error(error);

            // ✅ EXTRA PRO: si backend devuelve warnings incluso en error, los mostramos informativo
            const errData = error?.response?.data || null;
            const warnOnError = pickNuovoWarnings(errData);

            if (!silent && warnOnError.length > 0) {
                toast.warning(`Aviso NuovoPay: ${warnOnError.join(" | ")}`, {
                    position: "top-right",
                    autoClose: 8000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    theme: "colored",
                });
            }

            // Si quieres, aquí puedes mostrar toast de error general (lo dejo conservador)
            // if (!silent) toast.error("No se pudo registrar. Verifica e intenta nuevamente.");
            throw error;
        } finally {
            setLoading(false);
        }
    };

    const addRegisterRef = useRef(null);
    const isSavingRef = useRef(false);

    const addRegister = async (wizardPayload = null) => {
        // 🔒 BLOQUEO INMEDIATO ANTI DOBLE CLICK
        if (isSavingRef.current) return;
        isSavingRef.current = true;

        try {
            const sourceData =
                wizardPayload && typeof wizardPayload === "object"
                    ? wizardPayload
                    : formRef.current.getValues();

            const formData = {
                ...sourceData,
                sedeID: isRole3 ? ctxSedeId : sedeID,
            };

            const cat = String(formData?.cat ?? "");
            const subCat = String(formData?.subCat ?? "");

            // Cuota/FM: no permitir Guardar hasta terminar Cliente → Deuda → Pago → Confirmar.
            if (cat === "2" && (subCat === "2" || subCat === "6") && formData?.wizardCompleted !== true) {
                alert("Completa y confirma primero el flujo de Cliente → Deuda → Pago → Confirmar.");
                return;
            }

            // ❌ BLOQUEAR GUARDADO:
            // cat=1 subCat=1 => Venta a crédito de celular
            // cat=2 subCat=1 => Venta al contado de celular
            if ((cat === "1" || cat === "2") && subCat === "1") {
                alert(
                    "Error, no se permite guardar registros de venta de celular en esta sección.\n\n" +
                    "Categorías bloqueadas:\n" +
                    "- Venta a crédito de celular\n" +
                    "- Venta al contado de celular",
                );
                return;
            }

            // Para Cuota/FM el paso 4 del wizard ya es la confirmación explícita.
            // El resto de registros conserva exactamente la confirmación histórica.
            const comesFromWizard =
                wizardPayload && typeof wizardPayload === "object";

            if (!comesFromWizard) {
                const confirmRegister =
                    "¿Desea guardar este registro?\n\nLe recomendamos revisar la información para asegurar que sea correcta.";

                const accepted = window.confirm(confirmRegister);

                if (!accepted) {
                    return;
                }
            }

            // ===================== FM (Financiamiento Mixto): abrir modal antes de guardar =====================
            const isVenta =
                String(formData?.cat) === "1" && String(formData?.subCat) === "1";
            const wantsFM = String(formData?.fm) === "1";
            const fmAmountNum = parseMoneyPopup(formData?.fmAmount);
            const mustFinalizeFM = isVenta && wantsFM && fmAmountNum > 0;

            const errores = validarDatos(formData);

            if (errores.length > 0) {
                alert("Errores encontrados:\n" + errores.join("\n"));
                return;
            }

            // Si requiere FM, abrir popup y pausar guardado
            if (mustFinalizeFM) {
                setPendingFormData({ ...formData, fmAmount: fmAmountNum });
                setShowFmModal(true);
                return;
            }

            return await reallySaveRegister(formData);
        } finally {
            // 🔓 LIBERA EL BLOQUEO SIEMPRE
            isSavingRef.current = false;
        }
    };

    // useEffect(() => {
    //     addRegisterRef.current = addRegister;
    // }, []);

    const sedesFilterChange = (option) => {
        setSelectedAdvisor(null);
        const sedeID = option.value;
        setSedeID(sedeID);

        let [filterSede] =
            sedes && sedes.filter((item) => item.idNumber === sedeID);
        if (!filterSede) {
            [filterSede] = [
                { sede: "Todos", sedeLocation: "Se muestran todas las sedes" },
            ];
        }
        setSelectedSelect(option);
        setSedeName(filterSede.sede);
        setSedeLocation(filterSede.sedeLocation);
        setTipo(null);

        getFirstInfo(sedeID, fmt(startDate), fmt(endDate));
    };

    const sedeEngine = (e, sedeID, sedeName, sedeLocation) => {
        setSelectedAdvisor(null);
        setSedeID(sedeID);
        setSedeName(sedeName);
        setSedeLocation(sedeLocation);
        setShowListRegister(true);
        setTipo(null);

        getFirstInfo(sedeID, fmt(startDate), fmt(endDate));
        fetchPhones();
    };

    const handleDownloadExcel = async () => {
        setLoading(true);
        try {
            const url = `${process.env.REACT_APP_API}/download-registers`;
            const token = localStorage.getItem("token");

            const response = await axios.get(url, {
                responseType: "blob",
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
                timeout: 30000,
            });

            if (response && response.statusText === "OK") {
                const blob = new Blob([response.data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });

                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = "registros.xlsx";
                a.click();
            } else {
                alert("Hubo un error al descargar el archivo.");
            }
        } catch (error) {
            console.error("Error al obtener las sedes:", error);
            alert(
                error.message ||
                "Ocurrió un error al cargar las sedes. Por favor, intenta nuevamente.",
            );
        } finally {
            setLoading(false);
        }
    };

    function useIsMobileUA() {
        const [isMobile, setIsMobile] = useState(false);
        useEffect(() => {
            const ua = (navigator.userAgent || "").toLowerCase();
            setIsMobile(/iphone|ipad|ipod|android/.test(ua));
        }, []);
        return isMobile;
    }

    const customStyles = {
        option: (base, { selectProps, data }) => {
            const idx = selectProps.options.findIndex((o) => o.value === data.value);
            const isLast = idx === selectProps.options.length - 1;
            return { ...base, fontWeight: isLast ? "bold" : base.fontWeight };
        },
    };

    /* =========================== FLATPICKR =========================== */
    useEffect(() => {
        const timeout = setTimeout(() => {
            if (calendarInputRef.current) {
                // Evita múltiples instancias si el effect se vuelve a ejecutar
                if (calendarInputRef.current._flatpickr) {
                    calendarInputRef.current._flatpickr.destroy();
                }

                flatpickr(calendarInputRef.current, {
                    locale: Spanish,
                    mode: "range",
                    dateFormat: "Y-m-d",
                    closeOnSelect: false,

                    disable: [
                        function(date) {
                            const maxDate = moment().tz(TZ).endOf("day").toDate();

                            const isRole1 = String(rol) === "1";
                            const isRole8 = String(rol) === "8";

                            // Otros roles: desde el 28 del mes pasado
                            const minDateByMonth = moment()
                                .tz(TZ)
                                .subtract(1, "month")
                                .date(28)
                                .startOf("day")
                                .toDate();

                            // Rol 1: fecha fija
                            const minDateRole1 = moment
                                .tz("2025-07-11", TZ)
                                .startOf("day")
                                .toDate();

                            // Rol 8: últimos 2 meses
                            const minDateRole8 = moment()
                                .tz(TZ)
                                .subtract(2, "months")
                                .startOf("day")
                                .toDate();

                            const minDate = isRole1
                                ? minDateRole1
                                : isRole8
                                    ? minDateRole8
                                    : minDateByMonth;

                            return date < minDate || date > maxDate;
                        },
                    ],

                    onChange: function(selectedDates, dateStr, instance) {
                        setTipo(null);
                        setDateRange(selectedDates);

                        if (selectedDates.length < 2) {
                            setTimeout(() => instance.open(), 0);
                        }

                        if (selectedDates.length === 2) {
                            setSelectedAdvisor(null);

                            const [s, e] = selectedDates;

                            setStartDate(moment(s).tz(TZ).format("YYYY-MM-DD"));
                            setEndDate(moment(e).tz(TZ).format("YYYY-MM-DD"));

                            getFirstInfo(
                                isRole3 ? (ctxSedeId ?? null) : sedeID,
                                fmt(s),
                                fmt(e),
                            );

                            const formatDate = (date) =>
                                date.toLocaleDateString("es-ES", {
                                    weekday: "long",
                                    day: "numeric",
                                    month: "long",
                                });

                            const sameDay = s.toDateString() === e.toDateString();

                            const text = sameDay
                                ? `Mostrando "${formatDate(s)}"`
                                : `Mostrando del "${formatDate(s)}" al "${formatDate(e)}"`;

                            setShowText(text);

                            instance.close();
                        }
                    },
                });
            }
        }, 150);

        return () => clearTimeout(timeout);
    }, [sedeID, ctxSedeId, isRole3, rol]); // <-- agrega rol aquí

    /* =========================== CARGA INICIAL =========================== */
    useEffect(() => {
        const f1 = fmt(startDate);
        const f2 = fmt(endDate);

        if (isRole3) {
            if (ctxSedeId == null) return;
            getFirstInfo(ctxSedeId, f1, f2);
            setShowListRegister(true);
            fetchPhones();
        } else {
            getFirstInfo(null, f1, f2);
            setShowListRegister(true);
            fetchPhones();
        }

        getSedes();
        getAllUsers();
    }, [isRole3, ctxSedeId]); // eslint-disable-line

    const usersRoleMap = useMemo(() => {
        const m = new Map();
        (allUsers || []).forEach((u) => {
            m.set(keyId(u.userID), String(u.rol ?? ""));
        });
        return m;
    }, [allUsers]);

    useEffect(() => {
        if (!(String(rol) === "1" || String(rol) === "2")) return;
        if (!allUsers.length) return;

        const soldIds = new Set(
            allRegisters
                .filter((r) => (r.cat === 1 || r.cat === 2) && r.subCat === 1)
                .map((r) => String(r.userID)),
        );

        const zeroList = (allUsers || [])
            .map((u) => {
                const id = String(u.userID ?? u.id ?? u.idNumber ?? "");
                const nombre = u.nombre ?? u.name ?? "";
                const apIni = (
                    u.apellidoInicial ??
                    u.apellidoPaterno ??
                    u.paternalSur ??
                    (nombre[0] || "")
                )
                    .toString()
                    .charAt(0)
                    .toUpperCase();
                const rolU = String(u.rol ?? "");
                return {
                    userID: id,
                    nombre,
                    apellidoInicial: apIni,
                    rol: rolU,
                    records: 0,
                };
            })
            .filter((u) => u.rol === "3")
            .filter((u) => !soldIds.has(String(u.userID)));

        setUsersWithNoSales((prev) => {
            if (
                prev.length === zeroList.length &&
                prev.every((p, i) => String(p.userID) === String(zeroList[i]?.userID))
            ) {
                return prev;
            }
            return zeroList;
        });
    }, [rol, allUsers, allRegisters]);

    const advisorsRole3 = useMemo(() => {
        if (!advisors?.length) return [];
        if (usersRoleMap.size === 0) return advisors;
        return advisors.filter((a) => usersRoleMap.get(keyId(a.userID)) === "3");
    }, [advisors, usersRoleMap]);

    const normalizeCityName = (value) => {
        const raw = String(value || "Sin ciudad").trim();
        if (!raw) return "Sin ciudad";
        const compact = raw.toLowerCase().replace(/[\s_-]/g, "");
        const cityMap = {
            pucallpa: "Pucallpa",
            tarapoto: "Tarapoto",
            iquitos: "Iquitos",
            huanuco: "Huánuco",
            tingomaria: "Tingo María",
            callcenter: "Call Center",
            live: "Live",
        };
        return cityMap[compact] || raw.replace(/\b\w/g, (c) => c.toUpperCase());
    };

    const advisorCityGroups = useMemo(() => {
        const preferredOrder = [
            "Pucallpa",
            "Tarapoto",
            "Iquitos",
            "Huánuco",
            "Tingo María",
            "Call Center",
            "Live",
            "Sin ciudad",
        ];

        const groupsMap = new Map();

        (advisorsRole3 || []).forEach((advisor) => {
            const cityName = normalizeCityName(advisor.group || advisor.sedeName);
            if (!groupsMap.has(cityName)) {
                groupsMap.set(cityName, {
                    cityName,
                    totalSales: 0,
                    advisors: [],
                });
            }

            const group = groupsMap.get(cityName);
            group.totalSales += Number(advisor.records || 0);
            group.advisors.push(advisor);
        });

        return Array.from(groupsMap.values())
            .map((group) => ({
                ...group,
                advisors: [...group.advisors].sort(
                    (a, b) => Number(b.records || 0) - Number(a.records || 0),
                ),
            }))
            .sort((a, b) => {
                const aIdx = preferredOrder.indexOf(a.cityName);
                const bIdx = preferredOrder.indexOf(b.cityName);
                if (aIdx !== -1 || bIdx !== -1) {
                    return (aIdx === -1 ? 999 : aIdx) - (bIdx === -1 ? 999 : bIdx);
                }
                return a.cityName.localeCompare(b.cityName, "es");
            });
    }, [advisorsRole3]);

    const noSalesItems = (usersWithNoSales || [])
        .map((u) => {
            const id = keyId(u.userID || u.id || u.idNumber);
            const nombre = u.nombre || u.name || "";
            const apIni = (
                u.apellidoInicial ||
                u.apellidoPaterno ||
                u.paternalSur ||
                nombre[0] ||
                ""
            )
                .toString()
                .charAt(0)
                .toUpperCase();
            const rolU = String(u.rol ?? usersRoleMap.get(id) ?? "");
            return {
                userID: id,
                nombre,
                apellidoInicial: apIni,
                rol: rolU,
                records: 0,
            };
        })
        .filter((u) => String(u.rol) === "3");

    const AdvisorChip = ({ item, selected, onClick }) => {
        const hasSales = Number(item.records) > 0;

        return (
            <div
                className={`user-queue__item${selected && hasSales ? " selected" : ""}`}
                onClick={() => onClick?.(item.userID)}
                title={`${item.nombre} (${item.records})`}
            >
                <span className="user-queue__avatar">
                    {(item.apellidoInicial || item.nombre?.[0] || "A").toUpperCase()}
                </span>
                <span className="user-queue__name">
                    {`${item.nombre} ${item.apellidoInicial ? item.apellidoInicial + "." : ""}`}
                </span>
                <span className="user-queue__count">{item.records}</span>
            </div>
        );
    };

    const getWarrantyState = (row) =>
        Number(row?.warranty_state ?? row?.warrantyState ?? 0);

    const getWarrantyRowClass = (row) => {
        const warrantyState = getWarrantyState(row);

        if (warrantyState === 1) return "registerWarrantyPending";
        if ([2, 3].includes(warrantyState)) return "registerWarrantyMuted";

        return "";
    };

    const visibleRegisters = useMemo(() => {
        if (!Array.isArray(listRegister) || listRegister.length === 0) return [];
        return listRegister.slice(0, renderLimit);
    }, [listRegister, renderLimit]);

    useEffect(() => {
        setRenderLimit((prev) => {
            if (!listRegister?.length) return 220;
            return Math.min(Math.max(prev, 220), listRegister.length);
        });
    }, [listRegister]);

    useEffect(() => {
        const anchor = renderAnchorRef.current;
        if (!anchor || visibleRegisters.length >= (listRegister?.length || 0))
            return undefined;

        const observer = new IntersectionObserver(
            (entries) => {
                const first = entries[0];
                if (first?.isIntersecting) {
                    setRenderLimit((prev) => Math.min(prev + 180, listRegister.length));
                }
            },
            { rootMargin: "800px 0px" },
        );

        observer.observe(anchor);
        return () => observer.disconnect();
    }, [visibleRegisters.length, listRegister]);

    useEffect(() => {
        // console.log(ROLE_GROUPS.REGISTER_RESUME);
        isMountedRef.current = true;
        return () => {
            isMountedRef.current = false;
            if (requestAbortRef.current) {
                requestAbortRef.current.abort();
            }
        };
    }, []);

    const isMobile = useIsMobileUA();

    /* =========================== RENDER =========================== */

    return (
        <div>
            {loading && <PhoneLoader />}
            <ScrollToTop />
            <Header user={user} namePage={props.namePage} />
            <style>{`
        .registerCaption-actions .btnTicketRegister {
          min-height: 28px; padding: 0 10px; border: 1px solid #ddd6fe; background: #f5f3ff; color: #5b21b6;
          border-radius: 8px; display: inline-flex; align-items: center; justify-content: center; gap: 5px; cursor: pointer;
          font-size: 11px; font-weight: 800; line-height: 1; white-space: nowrap;
          transition: transform .15s ease, box-shadow .15s ease, background .15s ease;
        }
        .registerCaption-actions .btnTicketRegister:hover:not(:disabled) {
          transform: translateY(-1px); background: #ede9fe; box-shadow: 0 8px 18px rgba(91, 33, 182, .16);
        }
        .registerCaption-actions .btnTicketRegister:disabled { opacity: .65; cursor: wait; }
        .registerCaption-actions .btnTicketRegister svg { font-size: 13px; flex: 0 0 auto; }

        .registerCaption-actions .btnInitialVideoRegister {
          width: 28px; height: 28px; border: 1px solid #dbeafe; background: #eff6ff; color: #2563eb;
          border-radius: 8px; display: inline-flex; align-items: center; justify-content: center; cursor: pointer;
          transition: transform .15s ease, box-shadow .15s ease;
        }
        .registerCaption-actions .btnInitialVideoRegister:hover { transform: translateY(-1px); box-shadow: 0 8px 18px rgba(37, 99, 235, .18); }
        .registerRescheduleBadge { display:inline-flex; align-items:center; min-height:30px; padding:0 10px; border-radius:999px; background:#fff7ed; border:1px solid #fdba74; color:#9a3412; font-size:11px; font-weight:900; letter-spacing:.03em; white-space:nowrap; }
        .registerTable22 { border-color: #FA8514 !important; box-shadow: 0 10px 28px rgba(250, 133, 20, .15); }
        .registerTable22 thead tr, .registerTable22 caption { background: rgba(250, 133, 20, .12) !important; }
        .registerTable22 .cat, .registerTable22 .subCat { color: #C86608 !important; }

        .user-queue--cities {
          width: 100%;
          margin: 18px auto 14px;
          padding: 16px;
          border: 1px solid rgba(99, 102, 241, .14);
          border-radius: 20px;
          background: linear-gradient(180deg, #ffffff 0%, #fbfbff 100%);
          box-shadow: 0 16px 40px rgba(15, 23, 42, .08);
        }
        .user-queue__header {
          display: none;
        }
        .user-queue__eyebrow {
          display: block;
          color: #6d28d9;
          font-size: 11px;
          font-weight: 800;
          text-transform: uppercase;
          letter-spacing: .08em;
          margin-bottom: 3px;
        }
        .user-queue__header h3 {
          margin: 0;
          font-size: 18px;
          line-height: 1.1;
          color: #111827;
        }
        .user-queue__totalBadge {
          padding: 8px 12px;
          border-radius: 999px;
          background: #ede9fe;
          color: #5b21b6;
          font-weight: 800;
          white-space: nowrap;
        }
        .user-queue__citiesGrid{
          display: flex;
          column-gap: 12px;
        }
        .user-queue__cityCard {
          border: 1px solid #c0c9e9;
          border-radius: 16px;
          background: #fff;
          overflow: hidden;
          max-width: 290px;
        }
        .user-queue__cityHeader {
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 10px;
          padding: 12px 13px;
          background: linear-gradient(135deg, #f5f3ff, #ffffff);
          border-bottom: 1px solid #eef2ff;
        }
        .user-queue__cityLabel {
          display: block;
          font-size: 10px;
          color: #7c3aed;
          font-weight: 800;
          text-transform: uppercase;
          letter-spacing: .07em;
        }
        .user-queue__cityHeader strong {
          color: #111827;
          font-size: 15px;
        }
        .user-queue__cityCount {
          min-width: 34px;
          height: 34px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          border-radius: 12px;
          background: #6d28d9;
          color: white;
          font-weight: 900;
        }
        .user-queue__cityList {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          padding: 12px;
          padding-bottom: 0;
          padding-top: 2px;
        }
        .user-queue--cities .user-queue__item {
          margin: 0;
          border: 1px solid #e5e7eb;
          background: #ffffff;
          box-shadow: 0 6px 16px rgba(15, 23, 42, .05);
        }
        .user-queue--cities .user-queue__item:hover {
          transform: translateY(-1px);
          border-color: #c4b5fd;
          box-shadow: 0 10px 24px rgba(109, 40, 217, .13);
        }
        .user-queue--cities .user-queue__item.selected {
          border-color: #6d28d9;
          background: #f5f3ff;
        }
        @media (max-width: 640px) {
          .user-queue--cities { width: calc(100% - 14px); padding: 12px; border-radius: 16px; }
        }
        @media (max-width: 540px) {
          .user-queue__citiesGrid{
            flex-direction: column;
            align-items: center;
            row-gap: 10px;
          }
          .user-queue__cityCard{
            max-width: 100%;
            width: 92%;
          }
        }
      `}</style>

            <section className="sectionBody sectionBodyRegister">
                <div className="containerRegister">
                    {/* ===== Banner superior ===== */}
                    <div className="containerRegisterHeaderWrapper">
                        <div className="headerRegister containerCustom">
                            <div className="headerOne">
                                <div className="headerItem fullName">
                                    <ImUserCheck />
                                    <div>{fullName}</div>
                                </div>

                                <div className="headerItem sedeName">
                                    <div>{displaySedeName}</div>
                                    {displaySedeLocation ? (
                                        <div className="sedeLocation">{displaySedeLocation}</div>
                                    ) : null}
                                </div>
                            </div>

                            <div className="headerTwo">
                                <div className="headerItem sedeDate">
                                    <ImCalendar />
                                    <div className="dateTime">
                                        {moment()
                                            .tz(TZ)
                                            .locale("es")
                                            .format("DD [de] MMMM [del] YYYY")}
                                    </div>
                                    <ImClock />
                                    <Clock />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* ===== Resumenes / Filtros ===== */}
                    {listRegister && listRegister.length > 0 && String(rol) === "3" && (
                        <>
                            <div className="itemCountReg">
                                Total Registros:{" "}
                                <strong>{multiData?.kpis?.total_registros}</strong>
                            </div>
                            {multiData?.kpis &&
                                renderKpiGrid(KPI_CARDS_SELLER, multiData.kpis)}

                            <div className="salesTypeSummary">
                                <div className="typeItem">
                                    📦 PayJoy:{" "}
                                    <strong>{multiData && multiData.resumenVentas.payjoy}</strong>
                                </div>
                                <div className="typeItem">
                                    📦 MovilesPay:{" "}
                                    <strong>
                                        {multiData && multiData.resumenVentas.movilespay}
                                    </strong>
                                </div>
                                <div className="typeItem">
                                    📦 Efectiva:{" "}
                                    <strong>
                                        {multiData && multiData.resumenVentas.efectiva}
                                    </strong>
                                </div>
                                <div className="typeItem">
                                    📦 CrediSmart:{" "}
                                    <strong>
                                        {multiData && multiData.resumenVentas.credismart}
                                    </strong>
                                </div>
                                <div className="typeItem">
                                    📦 Alo Credit:{" "}
                                    <strong>
                                        {multiData && multiData.resumenVentas.alo_credit}
                                    </strong>
                                </div>
                                <div className="typeItem">
                                    📦 Contado:{" "}
                                    <strong>
                                        {multiData && multiData.resumenVentas.contado}
                                    </strong>
                                </div>
                                <div className="typeItem">
                                    📦 Egreso:{" "}
                                    <strong>{multiData && multiData.resumenVentas.egreso}</strong>
                                </div>
                                <div className="typeItem">
                                    📦 Retiro:{" "}
                                    <strong>{multiData && multiData.resumenVentas.salida}</strong>
                                </div>
                                <div className="typeItem">
                                    🛠️ Garantías:{" "}
                                    <strong>
                                        {multiData && multiData.resumenVentas.garantias}
                                    </strong>
                                </div>
                            </div>
                        </>
                    )}

                    {listRegister &&
                        ROLE_GROUPS.REGISTER_RESUME.includes(String(rol)) && (
                            <>
                                {multiData?.kpis &&
                                    ROLE_GROUPS.REGISTER_KPI.includes(String(rol)) &&
                                    renderKpiGrid(
                                        KPI_CARDS_ADMIN,
                                        { ...multiData.kpis, actual_registros: actualRegCount },
                                        {
                                            clickableKeys: CLICKABLE_KPIS,
                                            selectedKey: kpiSelected,
                                            onClickKpi: handleAdminKpiClick,
                                        },
                                    )}

                                <div className="salesTypeSummary">
                                    {ROLE_GROUPS.REGISTER_CITY.includes(String(rol)) && (
                                        <div className="sedesSelect">
                                            <div className="sedeHome">
                                                <ImHome2 />
                                            </div>
                                            <Select
                                                options={sedesFilter}
                                                value={selectedSelect}
                                                styles={customStyles}
                                                onChange={(e) => sedesFilterChange(e)}
                                                placeholder={"Selecciónar Sede"}
                                                className="selectForm formItem selectPhone registerSelectSede"
                                                classNamePrefix="sedesSelect"
                                                name="phoneName"
                                                formatGroupLabel={(group) => (
                                                    <div className="sedesSelectGroupHeading">
                                                        {group.label} ({Number(group.total || 0)})
                                                    </div>
                                                )}
                                            />
                                        </div>
                                    )}

                                    {ROLE_GROUPS.ADVISORS_TEAM.includes(String(rol)) && (
                                        <div className={"typeItem typeItemTotal"}>
                                            📦 Total Equipos:{" "}
                                            <strong>{typeCounts.totalEquipos}</strong>
                                        </div>
                                    )}
                                    <div
                                        className={
                                            tipo === "payjoy" ? "select typeItem select1" : "typeItem"
                                        }
                                        onClick={() => handleTipoClick("payjoy")}
                                    >
                                        📦 PayJoy: <strong>{typeCounts.payjoy}</strong>
                                    </div>
                                    <div
                                        className={
                                            tipo === "movilespay"
                                                ? "select typeItem select2"
                                                : "typeItem"
                                        }
                                        onClick={() => handleTipoClick("movilespay")}
                                    >
                                        📦 MovilesPay: <strong>{typeCounts.movilespay}</strong>
                                    </div>
                                    <div
                                        className={
                                            tipo === "efectiva"
                                                ? "select typeItem select3"
                                                : "typeItem"
                                        }
                                        onClick={() => handleTipoClick("efectiva")}
                                    >
                                        📦 Efectiva: <strong>{typeCounts.efectiva}</strong>
                                    </div>
                                    <div
                                        className={
                                            tipo === "credismart"
                                                ? "select typeItem select1"
                                                : "typeItem"
                                        }
                                        onClick={() => handleTipoClick("credismart")}
                                    >
                                        📦 CrediSmart: <strong>{typeCounts.credismart}</strong>
                                    </div>
                                    <div
                                        className={tipo === "alo_credit" ? "select typeItem" : "typeItem"}
                                        style={{ borderColor: "#FA8514", color: "#C86608" }}
                                        onClick={() => handleTipoClick("alo_credit")}
                                    >
                                        📦 Alo Credit: <strong>{typeCounts.alo_credit}</strong>
                                    </div>
                                    <div
                                        className={
                                            tipo === "contado"
                                                ? "select typeItem select4"
                                                : "typeItem"
                                        }
                                        onClick={() => handleTipoClick("contado")}
                                    >
                                        📦 Contado: <strong>{typeCounts.contado}</strong>
                                    </div>
                                    <div
                                        className={
                                            tipo === "egreso" ? "select typeItem select5" : "typeItem"
                                        }
                                        onClick={() => handleTipoClick("egreso")}
                                    >
                                        📦 Egreso: <strong>{typeCounts.egreso}</strong>
                                    </div>

                                    {String(rol) === "1" && (
                                        <div
                                            className={
                                                tipo === "salida"
                                                    ? "select typeItem select6"
                                                    : "typeItem"
                                            }
                                            onClick={() => handleTipoClick("salida")}
                                        >
                                            📦 Retiro: <strong>{typeCounts.salida}</strong>
                                        </div>
                                    )}

                                    <div
                                        className={
                                            tipo === "garantias"
                                                ? "select typeItem select7"
                                                : "typeItem"
                                        }
                                        onClick={() => handleTipoClick("garantias")}
                                    >
                                        🛠️ Garantías: <strong>{typeCounts.garantias}</strong>
                                    </div>

                                    <div
                                        className={
                                            tipo === "todos" ? "select typeItem select7" : "typeItem"
                                        }
                                        onClick={() => handleTipoClick("todos")}
                                    >
                                        📦 <strong>Todos</strong>
                                    </div>

                                    {/* {String(rol) === "1" && (
                    <div
                      className="select typeItem select7"
                      onClick={() => handleDownloadExcel()}
                    >
                      <strong>📥 Descargar Excel</strong>
                    </div>
                  )} */}

                                    <div className="calendarFilterWrapper">
                                        {showText && (
                                            <div className="calendarFilterMsg">{showText}</div>
                                        )}
                                        <label htmlFor="calendarFilter">
                                            <ImCalendar />
                                        </label>
                                        <input
                                            readOnly
                                            ref={calendarInputRef}
                                            className="filterDate"
                                            placeholder="Selecciona rango"
                                            id="calendarFilter"
                                        />
                                    </div>
                                </div>
                            </>
                        )}
                </div>

                {/* ===== ADVISORS ===== */}
                {ROLE_GROUPS.ADVISORS_TEAM.includes(String(rol)) &&
                    advisorCityGroups.length > 0 && (
                        <div className="user-queue holifrank user-queue--cities">
                            <div className="user-queue__header">
                                <div>
                                    <span className="user-queue__eyebrow">Ventas por ciudad</span>
                                    <h3>Ranking de asesores</h3>
                                </div>
                                <div className="user-queue__totalBadge">
                                    {advisorCityGroups.reduce(
                                        (acc, group) => acc + Number(group.totalSales || 0),
                                        0,
                                    )} ventas
                                </div>
                            </div>

                            <div className="user-queue__citiesGrid">
                                {advisorCityGroups.map((group) => (
                                    <div className="user-queue__cityCard" key={group.cityName}>
                                        <div className="user-queue__cityHeader">
                                            <div>
                                                <span className="user-queue__cityLabel">Ciudad</span>
                                                <strong>{group.cityName}</strong>
                                            </div>
                                            <span className="user-queue__cityCount">
                                                {group.totalSales}
                                            </span>
                                        </div>

                                        <div className="user-queue__cityList">
                                            {group.advisors.map((a) => (
                                                <AdvisorChip
                                                    key={a.userID}
                                                    item={a}
                                                    selected={keyId(selectedAdvisor) === keyId(a.userID)}
                                                    onClick={handleAdvisorClick}
                                                />
                                            ))}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                {/* ===== USUARIOS SIN VENTAS (0) ===== */}
                {ROLE_GROUPS.ADVISORS_TEAM.includes(String(rol)) &&
                    noSalesItems &&
                    noSalesItems.length > 0 && (
                        <div className="user-queue">
                            <div className="user-queue__list">
                                <div>
                                    {noSalesItems.map((u) => (
                                        <div key={u.userID} className="user-queue__item">
                                            <span className="user-queue__avatar">
                                                {(
                                                    u.apellidoInicial ||
                                                    u.nombre?.[0] ||
                                                    "A"
                                                ).toUpperCase()}
                                            </span>
                                            <span className="user-queue__name">
                                                {`${u.nombre} ${u.apellidoInicial ? u.apellidoInicial + "." : ""}`}
                                            </span>
                                            <span className="user-queue__count">0</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    )}

                {/* ===== Listados y tabla ===== */}
                <div className="registerAdd">
                    {showButtonAdd && String(rol) === "3" && !isMobile && (
                        <div className="registerAddWrapper" onClick={addComponent}>
                            <ImDatabase />
                            <span>Agregar</span>
                        </div>
                    )}
                    {!showButtonAdd && !wizardRegisterActive && String(rol) === "3" && !isMobile && (
                        <div className="registerAddRegister" onClick={() => addRegister()}>
                            <ImFolderUpload />
                            <span>Guardar</span>
                        </div>
                    )}
                </div>

                <div className="containerListRegister">
                    {componentList}
                    {visibleRegisters &&
                        visibleRegisters.map((item, index) => {
                            const warrantyRowClass = getWarrantyRowClass(item);
                            const warrantyState = getWarrantyState(item);

                            return (
                                <div
                                    key={item.id || index}
                                    className={`registerWarrantyRow ${warrantyRowClass}`}
                                    data-warranty-state={warrantyState}
                                >
                                    <TableCredito
                                        data={item}
                                        canEdit={String(rol) === "1" || String(rol) === "3"}
                                        onEdit={() => openEditModal(item)}
                                        onDelete={() => openDeleteModal(item)}
                                        onViewInitialVideo={() => openInitialVideoPopup(item)}
                                        onDownloadTicket={downloadRegisterTicket}
                                    />
                                </div>
                            );
                        })}

                    {!!listRegister?.length &&
                        visibleRegisters.length < listRegister.length && (
                            <div ref={renderAnchorRef} style={{ height: 1, width: "100%" }} />
                        )}
                </div>

                <InitialValidationVideoPopup
                    open={initialVideoPopup.open}
                    data={initialVideoPopup.data}
                    loading={initialVideoPopup.loading}
                    error={initialVideoPopup.error}
                    onClose={closeInitialVideoPopup}
                />

                <EditRegisterModal
                    open={!!editTarget}
                    data={editTarget}
                    phoneOptions={phoneOptions}
                    onClose={closeEditModal}
                    onSaved={(payload) => {
                        if (!payload) return;
                        const nextRegisters = normalizeRegisters(payload.registers || []);
                        setListRegister(nextRegisters);
                        setAllRegisters(nextRegisters);
                        setRenderLimit(220);
                        setMultiData(payload.multiData || null);
                    }}
                />

                {deleteTarget && (
                    <div
                        className={`popupConfirmPayment ${deleteAnimateOut ? "animateOut" : "fadeInZoom"}`}
                    >
                        <div className="popupConfirmPayment_wrapper">
                            <div className="popupConfirmPayment_content">
                                <h3>CONFIRMAR ELIMINACIÓN</h3>

                                <p style={{ fontSize: "14px", marginTop: "12px" }}>
                                    ¿Estás seguro que deseas eliminar este registro?
                                    <br />
                                    <strong>
                                        {deleteTarget.name} {deleteTarget.paternalSur} —{" "}
                                        {deleteTarget.phone}
                                    </strong>
                                </p>

                                <div
                                    className="buttonConfirmPay"
                                    onClick={handleConfirmDelete}
                                    style={{ marginTop: "30px", cursor: "pointer" }}
                                >
                                    {deleting ? "Eliminando..." : "Sí, eliminar"}
                                </div>

                                <div
                                    className="checkConfirmPay"
                                    onClick={closeDeleteModal}
                                    style={{ marginTop: "20px" }}
                                >
                                    <div>
                                        <ImCross />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {showUnlockPopup && (
                    <div
                        className={`popupConfirmPayment ${unlockAnimateOut ? "animateOut" : "fadeInZoom"}`}
                    >
                        <div className="popupConfirmPayment_wrapper">
                            <div className="popupConfirmPayment_content">
                                <h3>CÓDIGO DE DESBLOQUEO</h3>

                                <p style={{ fontSize: "14px", marginTop: "12px" }}>
                                    La cuota estaba vencida. Este es el código de desbloqueo:
                                </p>

                                <div
                                    style={{
                                        marginTop: "16px",
                                        fontSize: "26px",
                                        fontWeight: 800,
                                        letterSpacing: "2px",
                                        userSelect: "text",
                                    }}
                                >
                                    {unlockCode || "---"}
                                </div>

                                <div
                                    className="buttonConfirmPay"
                                    onClick={() => {
                                        try {
                                            if (unlockCode)
                                                navigator.clipboard?.writeText?.(String(unlockCode));
                                        } catch {}
                                        closeUnlockPopup();
                                    }}
                                    style={{ marginTop: "30px", cursor: "pointer" }}
                                >
                                    Copiar y cerrar
                                </div>

                                {/* <div
                                    className="checkConfirmPay"
                                    onClick={closeUnlockPopup}
                                    style={{ marginTop: "20px" }}
                                >
                                    <div><ImCross /></div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                )}

                {/* ===================== REPROGRAMACIÓN (Cuota MovilesPay) ===================== */}
                {showReschedulePopup && (
                    <div className={`popupConfirmPayment ${rescheduleAnimateOut ? "animateOut" : "fadeInZoom"}`}>
                        <div className="popupConfirmPayment_wrapper"><div className="popupConfirmPayment_content rescheduleUxPopup">
                        {rescheduleReviewStage===0&&<><div className="rescheduleEyebrow">MOVILESPAY · REPROGRAMACIÓN</div><h4>Configurar pago + reprogramación</h4>
                        <p className="rescheduleLead">Las primeras cuotas se pagan normalmente. <b>Solo la última cuota seleccionada se reprograma.</b></p>
                        <div className="rescheduleRule"><span>Pago normal</span><b>{Math.max(0,Number(rescheduleCtx?.numFees||1)-1)} cuota(s)</b><span>Pago + reprogramación</span><b>1 cuota</b></div>
                        <h5 className="popupConfirmPayment_subtitle">Fecha de la cuota que será reprogramada</h5>
                        <div className="resqueduleDaysList"><div className={rescheduleSelectIndex===0?"active":""} onClick={()=>doDayReschedule(0,moment().format("DD-MM-YYYY"))}>{moment().format("DD-MM-YYYY")} - <span>Hoy</span></div>
                        <div className={rescheduleSelectIndex===1?"active":""} onClick={()=>doDayReschedule(1,moment().add(1,"days").format("DD-MM-YYYY"))}>{moment().add(1,"days").format("DD-MM-YYYY")} - <span>{moment().add(1,"days").format("dddd")}</span></div></div>
                        <button className="buttonConfirmPay" onClick={confirmReschedule} disabled={!dayReschedule}>Revisar operación</button></>}
                        {rescheduleReviewStage===1&&reschedulePreview&&<><div className="rescheduleEyebrow">REVISIÓN ANTIERROR</div><h4>Detalle exacto de la operación</h4>
                        <div className="rescheduleBreakdown">{reschedulePreview.normalPaid.map(x=><div className="normal" key={`n-${x.id}`}><span>✓</span><div><b>Cuota N.º {x.id}</b><small>{x.date}</small></div><strong>PAGO NORMAL</strong></div>)}
                        <div className="pivot"><span>↻</span><div><b>Cuota N.º {reschedulePreview.pivot.id}</b><small>{reschedulePreview.pivot.date} → {moment(reschedulePreview.baseDate,"DD-MM-YYYY").format("DD/MM/YYYY")}</small></div><strong>PAGO + REPROGRAMACIÓN</strong></div></div>
                        <div className="rescheduleMeta"><span>Frecuencia <b>{reschedulePreview.frequency}</b></span><span>Cuotas cobradas <b>{reschedulePreview.requested}</b></span></div>
                        <div className="rescheduleActions"><button className="secondary" onClick={()=>setRescheduleReviewStage(0)}>Volver</button><button className="buttonConfirmPay" onClick={confirmReschedule}>Continuar</button></div></>}
                        {rescheduleReviewStage===2&&reschedulePreview&&<><div className="rescheduleEyebrow final">CONFIRMACIÓN FINAL</div><h4>Verifica antes de registrar</h4>
                        <div className="rescheduleFinal"><div>✓ {reschedulePreview.requested} cuota(s) cobradas</div><div>✓ {reschedulePreview.normalPaid.length} pago(s) normal(es)</div><div>↻ 1 sola cuota reprogramada: N.º {reschedulePreview.pivot.id}</div><div>✓ Frecuencia: {reschedulePreview.frequency}</div><div>✓ Fecha: {reschedulePreview.baseDate}</div></div>
                        <p className="rescheduleLead">El pago y el cronograma se guardarán en una sola operación.</p><div className="rescheduleActions"><button className="secondary" onClick={()=>setRescheduleReviewStage(1)}>Revisar nuevamente</button><button className="buttonConfirmPay" onClick={confirmReschedule} disabled={loading}>{loading?"Registrando...":"Confirmar operación"}</button></div></>}
                        <div className="rpClosePopup" onClick={closeReschedulePopup}><div><ImCross /></div></div></div></div>
                    </div>
                )}

                {/* *----------------------------------------------------* */}
                {showFinalizePopup && (
                    <div
                        className={`popupConfirmPayment popupConfirmPaymentFee ${finalizeAnimateOut ? "animateOut" : "fadeInZoom"}`}
                    >
                        <div className="popupConfirmPayment_wrapper">
                            <div className="popupConfirmPayment_content">
                                <h3>{payPopupTitle || "PAGO REGISTRADO"}</h3>

                                {/* {!!payPopupCuotas && (
                                    <p style={{ fontSize: "14px", marginTop: "10px", fontWeight: 700 }}>
                                        {payPopupCuotas}
                                    </p>
                                )} */}

                                {/* Resumen (Cuota Payjoy / MóvilesPay) debajo del body de cuota cuando NO finaliza */}
                                {!!payPopupSummary &&
                                    !payPopupFinalText &&
                                    renderPayPopupSummary(payPopupSummary)}

                                {!!payPopupFinalText && (
                                    <p
                                        style={{
                                            fontSize: "16px",
                                            marginTop: "10px",
                                            lineHeight: 1.4,
                                            whiteSpace: "pre-line",
                                            fontWeight: 500,
                                            color: "#333",
                                            letterSpacing: 1.5,
                                        }}
                                    >
                                        {payPopupFinalText}
                                    </p>
                                )}

                                {/* Resumen (Cuota Payjoy / MóvilesPay) debajo del mensaje de desinstalación cuando SÍ finaliza */}
                                {!!payPopupSummary &&
                                    !!payPopupFinalText &&
                                    renderPayPopupSummary(payPopupSummary)}

                                {payPopupWasLocked && unlockCode && (
                                    <>
                                        <h4
                                            style={{
                                                fontSize: "14px",
                                                marginTop: "14px",
                                                marginBottom: "0",
                                            }}
                                        >
                                            Código de desbloqueo:
                                        </h4>

                                        <div
                                            style={{
                                                marginTop: "0px",
                                                fontSize: "22px",
                                                fontWeight: 800,
                                                letterSpacing: "2px",
                                                userSelect: "text",
                                            }}
                                        >
                                            {unlockCode || "---"}
                                        </div>

                                        {/* <div
                                            className="buttonConfirmPay"
                                            onClick={() => {
                                                try {
                                                    if (unlockCode) navigator.clipboard?.writeText?.(String(unlockCode));
                                                } catch { }
                                            }}
                                            style={{ marginTop: "18px", cursor: "pointer" }}
                                        >
                                            Copiar código
                                        </div> */}
                                    </>
                                )}

                                <div
                                    className="buttonConfirmPay"
                                    onClick={closeFinalizePopup}
                                    style={{ marginTop: "22px", cursor: "pointer" }}
                                >
                                    Entendido
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </section>

            {/* === POPUP FM CENTRALIZADO === */}
            <FmFinalizePopup
                open={showFmModal}
                onClose={() => setShowFmModal(false)}
                initial={{
                    cat: pendingFormData ? String(pendingFormData.cat) : undefined,
                    subCat: pendingFormData ? String(pendingFormData.subCat) : undefined,
                    segment: pendingFormData
                        ? String(pendingFormData.segment)
                        : undefined,
                    amountFM: pendingFormData?.fmAmount,
                    dni: pendingFormData?.dni,
                    name: pendingFormData?.name,
                    paternalSur: pendingFormData?.paternalSur,
                    maternalSur: pendingFormData?.maternalSur,
                    email: pendingFormData?.email,
                    addressName: "",
                    phoneNumber: pendingFormData?.phoneNumber,
                    modelPhone: pendingFormData?.phone,
                    imei: pendingFormData?.imei,
                }}
                forcePayjoyMode={false}
                hideCuota={
                    String(pendingFormData?.cat) === "2" &&
                    String(pendingFormData?.subCat) === "1" &&
                    String(pendingFormData?.segment) === "4"
                }
                onCreated={async () => {
                    if (pendingFormData) {
                        await reallySaveRegister(pendingFormData);
                        setPendingFormData(null);
                    }
                }}
            />

            <Footer />
        </div>
    );
}

export default RegisterPage
